/* @ds-bundle: {"format":3,"namespace":"CaniglooDesignSystem_665af4","components":[{"name":"Badge","sourcePath":"components/core/Badge.jsx"},{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Card","sourcePath":"components/core/Card.jsx"},{"name":"Eyebrow","sourcePath":"components/core/Eyebrow.jsx"},{"name":"Input","sourcePath":"components/core/Input.jsx"},{"name":"Rating","sourcePath":"components/core/Rating.jsx"},{"name":"IconWind","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconPlugOff","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconWash","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconTruck","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconShield","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconLock","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconReturn","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconBed","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconSmile","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconSun","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconPaw","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconChevronDown","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconCart","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconArrowRight","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconPlus","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconMinus","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconClose","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconMenu","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconCheck","sourcePath":"ui_kits/shopify/Icons.jsx"},{"name":"IconHeart","sourcePath":"ui_kits/shopify/Icons.jsx"}],"sourceHashes":{"components/core/Badge.jsx":"fad6cf0de11c","components/core/Button.jsx":"c9dbd8679772","components/core/Card.jsx":"bf807038d605","components/core/Eyebrow.jsx":"6707e4940417","components/core/Input.jsx":"f3b4bbd857b8","components/core/Rating.jsx":"a3a53b168121","pages/a-propos/a-propos-app.jsx":"0cc62dd57b8a","pages/a-propos/tweaks-panel.jsx":"6591467622ed","pages/blog/blog-app.jsx":"bf5f9bc485c6","pages/blog/blog-data.js":"6594dbb25f72","pages/blog/tweaks-panel.jsx":"6591467622ed","pages/contact/contact-app.jsx":"a6d55ee3394e","pages/contact/tweaks-panel.jsx":"6591467622ed","pages/faq/faq-app.jsx":"4252e1966f8a","pages/faq/faq-data.js":"46fe4c9eda75","pages/faq/faq-parts.jsx":"6e44c5fd03ca","pages/faq/tweaks-panel.jsx":"6591467622ed","pages/produit/produit-app.jsx":"99bfe410954e","pages/produit/produit-parts.jsx":"ab2c5dc26b99","pages/produit/produit-sections.jsx":"68bba33bfc07","pages/produit/tweaks-panel.jsx":"6591467622ed","ui_kits/shopify/Icons.jsx":"25765b2e91bb","ui_kits/shopify/app.js":"446ea08babcf","ui_kits/shopify/sectionsBottom.js":"71e5ef625613","ui_kits/shopify/sectionsMid.js":"2c602410393d","ui_kits/shopify/sectionsTop.js":"8a806987a450"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.CaniglooDesignSystem_665af4 = window.CaniglooDesignSystem_665af4 || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/core/Badge.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Canigloo Badge / pill — small label for tags, reassurance chips, statuses.
 */
function Badge({
  children,
  tone = 'teal',
  size = 'md',
  icon = null,
  style = {},
  ...rest
}) {
  const tones = {
    teal: {
      bg: 'var(--teal-light)',
      color: 'var(--teal-deep)'
    },
    orange: {
      bg: 'var(--orange-tint)',
      color: 'var(--orange)'
    },
    neutral: {
      bg: '#EEF4F6',
      color: 'var(--muted)'
    },
    success: {
      bg: 'var(--success-bg)',
      color: 'var(--success)'
    },
    danger: {
      bg: 'var(--danger-bg)',
      color: 'var(--danger)'
    },
    solid: {
      bg: 'var(--teal)',
      color: '#fff'
    },
    accent: {
      bg: 'var(--orange)',
      color: '#fff'
    }
  };
  const t = tones[tone] || tones.teal;
  const sizes = {
    sm: {
      fontSize: 10.5,
      padding: '4px 9px',
      gap: 4
    },
    md: {
      fontSize: 12,
      padding: '5px 12px',
      gap: 6
    },
    lg: {
      fontSize: 13,
      padding: '7px 14px',
      gap: 6
    }
  };
  const s = sizes[size] || sizes.md;
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: s.gap,
      background: t.bg,
      color: t.color,
      fontFamily: 'var(--font-sans)',
      fontWeight: 'var(--fw-semibold)',
      fontSize: s.fontSize,
      lineHeight: 1.2,
      padding: s.padding,
      borderRadius: 'var(--radius-pill)',
      whiteSpace: 'nowrap',
      ...style
    }
  }, rest), icon, children);
}
Object.assign(__ds_scope, { Badge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Badge.jsx", error: String((e && e.message) || e) }); }

// components/core/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Canigloo Button.
 * Primary = orange CTA (rare, high-intent). Secondary = teal. Ghost / link for low emphasis.
 */
function Button({
  children,
  variant = 'primary',
  size = 'md',
  block = false,
  disabled = false,
  iconLeft = null,
  iconRight = null,
  type = 'button',
  onClick,
  style = {},
  ...rest
}) {
  const sizes = {
    sm: {
      padding: '8px 16px',
      fontSize: 13,
      gap: 6,
      radius: 'var(--radius-sm)'
    },
    md: {
      padding: '13px 24px',
      fontSize: 15,
      gap: 8,
      radius: 'var(--radius-sm)'
    },
    lg: {
      padding: '17px 32px',
      fontSize: 16.5,
      gap: 10,
      radius: 'var(--radius-md)'
    }
  };
  const s = sizes[size] || sizes.md;
  const variants = {
    primary: {
      background: 'var(--action-primary)',
      color: 'var(--text-on-brand)',
      border: '1px solid transparent',
      boxShadow: 'var(--shadow-cta)'
    },
    secondary: {
      background: 'var(--action-secondary)',
      color: 'var(--text-on-brand)',
      border: '1px solid transparent',
      boxShadow: 'none'
    },
    outline: {
      background: 'transparent',
      color: 'var(--text-brand-deep)',
      border: '1px solid var(--teal)',
      boxShadow: 'none'
    },
    ghost: {
      background: 'transparent',
      color: 'var(--text-brand-deep)',
      border: '1px solid transparent',
      boxShadow: 'none'
    },
    link: {
      background: 'transparent',
      color: 'var(--text-accent)',
      border: '1px solid transparent',
      boxShadow: 'none',
      padding: 0,
      textDecoration: 'underline',
      textUnderlineOffset: 3
    }
  };
  const v = variants[variant] || variants.primary;
  const base = {
    fontFamily: 'var(--font-sans)',
    fontWeight: 'var(--fw-semibold)',
    fontSize: s.fontSize,
    lineHeight: 1.1,
    letterSpacing: '0.1px',
    padding: variant === 'link' ? 0 : s.padding,
    borderRadius: s.radius,
    display: block ? 'flex' : 'inline-flex',
    width: block ? '100%' : 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    gap: s.gap,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transition: 'transform var(--dur-fast) var(--ease-soft), filter var(--dur-base) var(--ease-soft), box-shadow var(--dur-base) var(--ease-soft)',
    WebkitTapHighlightColor: 'transparent',
    ...v,
    ...style
  };
  const hoverEnter = e => {
    if (disabled) return;
    if (variant === 'primary' || variant === 'secondary') e.currentTarget.style.filter = 'brightness(0.94)';
    if (variant === 'outline' || variant === 'ghost') e.currentTarget.style.background = 'var(--teal-50)';
  };
  const hoverLeave = e => {
    if (disabled) return;
    e.currentTarget.style.filter = 'none';
    if (variant === 'outline' || variant === 'ghost') e.currentTarget.style.background = 'transparent';
  };
  const press = e => {
    if (!disabled) e.currentTarget.style.transform = 'scale(0.97)';
  };
  const release = e => {
    if (!disabled) e.currentTarget.style.transform = 'none';
  };
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type,
    disabled: disabled,
    onClick: onClick,
    style: base,
    onMouseEnter: hoverEnter,
    onMouseLeave: e => {
      hoverLeave(e);
      release(e);
    },
    onMouseDown: press,
    onMouseUp: release
  }, rest), iconLeft, children, iconRight);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/core/Card.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Canigloo Card — soft, rounded container. Brand leans on hairline borders
 * and gentle teal fills rather than heavy shadows.
 */
function Card({
  children,
  variant = 'default',
  padding = 'md',
  radius = 'lg',
  hoverable = false,
  style = {},
  ...rest
}) {
  const variants = {
    default: {
      background: 'var(--surface-card)',
      border: '1px solid var(--line)',
      color: 'var(--text-body)',
      boxShadow: 'none'
    },
    soft: {
      background: 'var(--teal-light)',
      border: '1px solid transparent',
      color: '#1c3a45',
      boxShadow: 'none'
    },
    accent: {
      background: 'var(--orange-wash)',
      border: '1px solid #FBD5C2',
      color: 'var(--ink-soft)',
      boxShadow: 'none'
    },
    brand: {
      background: 'var(--surface-brand-deep)',
      border: '1px solid transparent',
      color: '#fff',
      boxShadow: 'none'
    },
    elevated: {
      background: 'var(--surface-card)',
      border: '1px solid var(--line)',
      color: 'var(--text-body)',
      boxShadow: 'var(--shadow-md)'
    }
  };
  const v = variants[variant] || variants.default;
  const pads = {
    none: 0,
    sm: 'var(--space-4)',
    md: 'var(--space-6)',
    lg: 'var(--space-8)'
  };
  const radii = {
    sm: 'var(--radius-sm)',
    md: 'var(--radius-md)',
    lg: 'var(--radius-lg)',
    xl: 'var(--radius-xl)'
  };
  const base = {
    borderRadius: radii[radius] || radii.lg,
    padding: pads[padding] ?? pads.md,
    fontFamily: 'var(--font-sans)',
    transition: 'transform var(--dur-base) var(--ease-soft), box-shadow var(--dur-base) var(--ease-soft)',
    ...v,
    ...style
  };
  const enter = e => {
    if (hoverable) {
      e.currentTarget.style.transform = 'translateY(-3px)';
      e.currentTarget.style.boxShadow = 'var(--shadow-md)';
    }
  };
  const leave = e => {
    if (hoverable) {
      e.currentTarget.style.transform = 'none';
      e.currentTarget.style.boxShadow = v.boxShadow;
    }
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    style: base,
    onMouseEnter: enter,
    onMouseLeave: leave
  }, rest), children);
}
Object.assign(__ds_scope, { Card });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Card.jsx", error: String((e && e.message) || e) }); }

// components/core/Eyebrow.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Canigloo Eyebrow — small uppercase, wide-tracked label that sits above
 * headings. Teal by default; the brand's signature section kicker.
 */
function Eyebrow({
  children,
  tone = 'teal',
  as = 'div',
  wide = false,
  style = {},
  ...rest
}) {
  const colors = {
    teal: 'var(--text-brand)',
    orange: 'var(--text-accent)',
    muted: 'var(--muted)',
    light: 'rgba(255,255,255,0.85)'
  };
  const Tag = as;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: wide ? 12 : 11,
      fontWeight: 'var(--fw-semibold)',
      letterSpacing: wide ? 'var(--ls-kicker)' : 'var(--ls-eyebrow)',
      textTransform: 'uppercase',
      color: colors[tone] || colors.teal,
      ...style
    }
  }, rest), children);
}
Object.assign(__ds_scope, { Eyebrow });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Eyebrow.jsx", error: String((e && e.message) || e) }); }

// components/core/Input.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Canigloo text input with optional label, hint and error.
 */
function Input({
  label,
  hint,
  error,
  id,
  type = 'text',
  value,
  defaultValue,
  placeholder,
  onChange,
  disabled = false,
  style = {},
  ...rest
}) {
  const [focused, setFocused] = React.useState(false);
  const inputId = id || (label ? 'in-' + String(label).toLowerCase().replace(/\s+/g, '-') : undefined);
  const borderColor = error ? 'var(--danger)' : focused ? 'var(--teal)' : 'var(--line)';
  return /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-sans)',
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      ...style
    }
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    style: {
      fontSize: 13,
      fontWeight: 'var(--fw-semibold)',
      color: 'var(--text-heading)'
    }
  }, label), /*#__PURE__*/React.createElement("input", _extends({
    id: inputId,
    type: type,
    value: value,
    defaultValue: defaultValue,
    placeholder: placeholder,
    onChange: onChange,
    disabled: disabled,
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
    style: {
      fontFamily: 'var(--font-sans)',
      fontSize: 15,
      color: 'var(--text-heading)',
      background: disabled ? '#F4F8F9' : '#fff',
      border: `1.5px solid ${borderColor}`,
      borderRadius: 'var(--radius-sm)',
      padding: '12px 14px',
      outline: 'none',
      boxShadow: focused && !error ? '0 0 0 4px rgba(8,145,178,0.12)' : 'none',
      transition: 'border-color var(--dur-base) var(--ease-soft), box-shadow var(--dur-base) var(--ease-soft)',
      width: '100%'
    }
  }, rest)), (hint || error) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12,
      color: error ? 'var(--danger)' : 'var(--muted)'
    }
  }, error || hint));
}
Object.assign(__ds_scope, { Input });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Input.jsx", error: String((e && e.message) || e) }); }

// components/core/Rating.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Canigloo star rating — review stars with optional count label.
 */
function Rating({
  value = 5,
  max = 5,
  size = 16,
  count,
  label,
  style = {},
  ...rest
}) {
  const stars = [];
  for (let i = 0; i < max; i++) {
    const fill = i < Math.round(value);
    stars.push(/*#__PURE__*/React.createElement("svg", {
      key: i,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      style: {
        display: 'block'
      }
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.46L12 17.3 6.2 20.36l1.11-6.46-4.7-4.58 6.49-.94L12 2.5z",
      fill: fill ? 'var(--star)' : 'none',
      stroke: fill ? 'var(--star)' : 'var(--line)',
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })));
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      fontFamily: 'var(--font-sans)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      gap: 2
    }
  }, stars), (count != null || label) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13,
      color: 'var(--muted)',
      fontWeight: 'var(--fw-medium)'
    }
  }, label || `${value.toFixed(1)} (${count})`));
}
Object.assign(__ds_scope, { Rating });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Rating.jsx", error: String((e && e.message) || e) }); }

// pages/a-propos/a-propos-app.jsx
try { (() => {
/* Canigloo — Page À propos : histoire, manifeste, engagements.
   Réutilise le chrome (header/footer) de window.CG_FAQ_PARTS. */

const NSa = () => window.CaniglooDesignSystem_665af4 || {};
const AP_EASE = 'cubic-bezier(0.22,0.61,0.36,1)';
const AP_TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "fond": "Blanc",
  "photo_hero": true
} /*EDITMODE-END*/;
const AP_BG = {
  'Blanc': '#FFFFFF',
  'Crème': '#F7F3EC'
};
function ApContainer({
  children,
  style,
  className
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: {
      maxWidth: 1180,
      margin: '0 auto',
      padding: '0 24px',
      ...style
    }
  }, children);
}

/* ---------- Hero ---------- */
function ApHero({
  photo
}) {
  const {
    Eyebrow
  } = NSa();
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "\xC0 propos \u2014 Hero",
    style: {
      background: 'linear-gradient(180deg, var(--teal-50) 0%, transparent 100%)'
    }
  }, /*#__PURE__*/React.createElement(ApContainer, {
    style: {
      textAlign: 'center',
      padding: '64px 24px 50px',
      maxWidth: 860
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    wide: true,
    style: {
      marginBottom: 16
    }
  }, "\xC0 propos de Canigloo") : null, /*#__PURE__*/React.createElement("h1", {
    className: "ap-hero-h1",
    style: {
      fontWeight: 800,
      letterSpacing: '-1.2px',
      lineHeight: 1.05,
      color: 'var(--ink)',
      margin: '0 0 18px'
    }
  }, "On s'occupe de lui.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--teal)'
    }
  }, "On pense \xE0 toi.")), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 17.5,
      lineHeight: 1.65,
      color: 'var(--ink-soft)',
      margin: '0 auto',
      maxWidth: 580
    }
  }, "Canigloo est une marque fran\xE7aise n\xE9e d'un constat tout simple : quand ton chien souffre de la chaleur, c'est toi qui ne profites plus de l'\xE9t\xE9.")), photo ? /*#__PURE__*/React.createElement(ApContainer, {
    style: {
      paddingBottom: 8
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('homepage-hero.jpg'),
    alt: "Chien heureux allong\xE9 dans un coin frais, lumi\xE8re d'\xE9t\xE9",
    style: {
      width: '100%',
      height: 380,
      objectFit: 'cover',
      borderRadius: 'var(--radius-xl, 24px)',
      display: 'block'
    }
  })) : null);
}

/* ---------- L'histoire ---------- */
function ApStory() {
  const {
    Eyebrow
  } = NSa();
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "\xC0 propos \u2014 Histoire"
  }, /*#__PURE__*/React.createElement(ApContainer, {
    style: {
      padding: '64px 24px 56px',
      maxWidth: 720
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    style: {
      marginBottom: 14
    }
  }, "Notre histoire") : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 32,
      fontWeight: 800,
      letterSpacing: '-0.7px',
      lineHeight: 1.12,
      color: 'var(--ink)',
      margin: '0 0 22px'
    }
  }, "Tout est parti d'un apr\xE8s-midi de canicule."), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 16,
      lineHeight: 1.75,
      color: 'var(--ink-soft)',
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0
    }
  }, "14h, 32 degr\xE9s. Un chien qui tourne en rond dans l'appartement, qui hal\xE8te, qui cherche le carrelage, qui change de pi\xE8ce sans jamais trouver sa place. Et son ma\xEEtre qui le regarde, avec cette petite voix dans la t\xEAte : ", /*#__PURE__*/React.createElement("em", {
    style: {
      color: 'var(--ink)'
    }
  }, "\xAB est-ce que j'en fais assez pour lui ? \xBB")), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0
    }
  }, "Cette sc\xE8ne, on l'a v\xE9cue. Et on a d\xE9couvert qu'on \xE9tait des milliers \xE0 la vivre chaque \xE9t\xE9, sans vraie solution simple : la clim n'est pas pour lui, les tapis gel se d\xE9chargent en vingt minutes, et le canap\xE9 tient chaud."), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0
    }
  }, "Alors on a cr\xE9\xE9 Canigloo \u2014 et IceDream, un matelas en coton respirant qui reste frais sans eau, sans gel, sans \xE9lectricit\xE9. Pas une r\xE9volution technologique. Juste un coin frais \xE0 lui, qui marche, et qui se lave en machine."))));
}

/* ---------- Citation manifeste ---------- */
function ApQuote() {
  const {
    IconPaw
  } = NSa();
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "\xC0 propos \u2014 Manifeste",
    style: {
      background: 'var(--teal-darker)',
      color: '#fff',
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: -30,
      right: -20,
      opacity: 0.1,
      color: '#fff',
      pointerEvents: 'none'
    }
  }, IconPaw ? /*#__PURE__*/React.createElement(IconPaw, {
    size: 190
  }) : null), /*#__PURE__*/React.createElement(ApContainer, {
    style: {
      padding: '72px 24px',
      maxWidth: 860,
      textAlign: 'center',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "ap-quote",
    style: {
      fontSize: 30,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      lineHeight: 1.25,
      margin: '0 0 18px'
    }
  }, "\xAB On ne vend pas du froid.", /*#__PURE__*/React.createElement("br", null), "On vend le soulagement de le voir ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#FFD9C2'
    }
  }, "enfin bien"), ". \xBB"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15.5,
      color: 'rgba(255,255,255,0.85)',
      margin: 0,
      lineHeight: 1.6
    }
  }, "C'est l'id\xE9e directrice de tout ce qu'on fait : on ne parle pas qu'\xE0 ton chien. On te parle \xE0 toi.")));
}

/* ---------- Valeurs ---------- */
function ApValues() {
  const {
    Eyebrow,
    Card,
    IconCheck,
    IconSmile,
    IconShield
  } = NSa();
  const values = [{
    icon: IconCheck,
    t: "L'honnêteté avant tout",
    d: "IceDream, c'est du coton respirant — pas du gel, pas de la « technologie spatiale ». On te promet du frais qui dure, jamais du froid glacial. Si un produit ne tient pas sa promesse, on ne le vend pas."
  }, {
    icon: IconSmile,
    t: 'On parle au maître',
    d: "Derrière chaque chien qui a chaud, il y a un humain qui culpabilise. Notre métier, c'est d'enlever ce poids-là : tu sais que tu as prévu quelque chose pour lui, tu peux souffler."
  }, {
    icon: IconShield,
    t: 'Simple, sinon rien',
    d: "Pas de recharge, pas de branchement, pas de mode d'emploi. Tu poses le matelas, il s'allonge, tu le laves en machine. La simplicité est une forme de respect."
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "\xC0 propos \u2014 Valeurs",
    style: {
      background: 'var(--cream)'
    }
  }, /*#__PURE__*/React.createElement(ApContainer, {
    style: {
      padding: '68px 24px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: 38
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    style: {
      marginBottom: 12
    }
  }, "Ce qui nous guide") : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 32,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      color: 'var(--ink)',
      margin: 0
    }
  }, "Trois r\xE8gles qu'on ne n\xE9gocie pas.")), /*#__PURE__*/React.createElement("div", {
    className: "ap-values",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 20
    }
  }, values.map(v => Card ? /*#__PURE__*/React.createElement(Card, {
    key: v.t,
    variant: "default",
    padding: "lg",
    radius: "lg"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 50,
      height: 50,
      borderRadius: 'var(--radius-md, 12px)',
      background: 'var(--teal-light)',
      color: 'var(--teal-deep)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 18
    }
  }, v.icon ? /*#__PURE__*/React.createElement(v.icon, {
    size: 24
  }) : null), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 18,
      fontWeight: 700,
      color: 'var(--ink)',
      margin: '0 0 8px'
    }
  }, v.t), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14.5,
      lineHeight: 1.6,
      color: 'var(--muted)',
      margin: 0
    }
  }, v.d)) : null))));
}

/* ---------- Engagements ---------- */
function ApCommitments() {
  const {
    Eyebrow,
    IconTruck,
    IconReturn,
    IconLock,
    IconPaw
  } = NSa();
  const rows = [{
    icon: IconTruck,
    t: 'Livraison suivie en 7 à 10 jours',
    d: "Partout en France, avec un numéro de suivi envoyé par email dès l'expédition. C'est promis."
  }, {
    icon: IconReturn,
    t: 'Satisfait ou remboursé',
    d: "S'il ne l'adopte pas, on te rembourse. Pas de formulaire à rallonge, pas de question piège."
  }, {
    icon: IconLock,
    t: 'Paiement sécurisé',
    d: 'Toutes les transactions passent par la plateforme sécurisée de Shopify, avec chiffrement SSL et 3D Secure.'
  }, {
    icon: IconPaw,
    t: 'Un humain te répond',
    d: "Une question, un souci, un doute ? Tu nous écris, et c'est une vraie personne qui te répond — sous 24 h ouvrées."
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "\xC0 propos \u2014 Engagements"
  }, /*#__PURE__*/React.createElement(ApContainer, {
    style: {
      padding: '68px 24px',
      maxWidth: 880
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: 36
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    style: {
      marginBottom: 12
    }
  }, "Nos engagements") : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 32,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      color: 'var(--ink)',
      margin: 0
    }
  }, "Ce que tu peux attendre de nous.")), /*#__PURE__*/React.createElement("div", {
    className: "ap-commitments",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 16
    }
  }, rows.map(r => /*#__PURE__*/React.createElement("div", {
    key: r.t,
    style: {
      display: 'flex',
      gap: 16,
      alignItems: 'flex-start',
      background: '#fff',
      border: '1px solid var(--line)',
      borderRadius: 'var(--radius-lg, 16px)',
      padding: '22px 24px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 44,
      height: 44,
      borderRadius: 12,
      background: 'var(--teal-light)',
      color: 'var(--teal-deep)',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    }
  }, r.icon ? /*#__PURE__*/React.createElement(r.icon, {
    size: 21
  }) : null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 16,
      fontWeight: 700,
      color: 'var(--ink)',
      margin: '0 0 5px'
    }
  }, r.t), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 13.5,
      lineHeight: 1.6,
      color: 'var(--muted)',
      margin: 0
    }
  }, r.d)))))));
}

/* ---------- CTA final ---------- */
function ApCta() {
  const {
    Button,
    IconArrowRight
  } = NSa();
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "\xC0 propos \u2014 CTA",
    style: {
      background: 'var(--cream)'
    }
  }, /*#__PURE__*/React.createElement(ApContainer, {
    style: {
      padding: '64px 24px 76px',
      maxWidth: 900
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-cta",
    style: {
      background: 'linear-gradient(135deg, var(--teal) 0%, var(--teal-deep) 100%)',
      borderRadius: 'var(--radius-xl, 24px)',
      padding: '52px 48px',
      textAlign: 'center',
      color: '#fff'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 30,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      margin: '0 0 10px',
      lineHeight: 1.12
    }
  }, "Ton chien m\xE9rite un \xE9t\xE9 parfait."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 16,
      color: 'rgba(255,255,255,0.9)',
      margin: '0 0 26px'
    }
  }, "Et toi, tu m\xE9rites d'en profiter aussi."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 14,
      justifyContent: 'center',
      flexWrap: 'wrap'
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    iconRight: IconArrowRight ? /*#__PURE__*/React.createElement(IconArrowRight, {
      size: 18
    }) : null,
    onClick: () => {
      window.location.href = '/pages/produit';
    }
  }, "D\xE9couvrir IceDream") : null, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    size: "lg",
    onClick: () => {
      window.location.href = '/pages/faq';
    },
    style: {
      color: '#fff'
    }
  }, "Lire la FAQ") : null))));
}

/* ---------- App ---------- */
function ApApp() {
  const P = window.CG_FAQ_PARTS;
  const [t, setTweak] = useTweaks(AP_TWEAK_DEFAULTS);
  const pageBg = AP_BG[t.fond] || '#fff';
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: pageBg,
      minHeight: '100vh',
      transition: 'background .3s'
    }
  }, /*#__PURE__*/React.createElement(P.FaqAnnouncement, null), /*#__PURE__*/React.createElement(P.FaqHeader, {
    active: "\xC0 propos"
  }), /*#__PURE__*/React.createElement(ApHero, {
    photo: t.photo_hero
  }), /*#__PURE__*/React.createElement(ApStory, null), /*#__PURE__*/React.createElement(ApQuote, null), /*#__PURE__*/React.createElement(ApValues, null), /*#__PURE__*/React.createElement(ApCommitments, null), /*#__PURE__*/React.createElement(ApCta, null), /*#__PURE__*/React.createElement(P.FaqFooter, null), /*#__PURE__*/React.createElement(TweaksPanel, null, /*#__PURE__*/React.createElement(TweakSection, {
    label: "Style"
  }), /*#__PURE__*/React.createElement(TweakRadio, {
    label: "Fond",
    value: t.fond,
    options: ['Blanc', 'Crème'],
    onChange: v => setTweak('fond', v)
  }), /*#__PURE__*/React.createElement(TweakToggle, {
    label: "Photo dans le hero",
    value: t.photo_hero,
    onChange: v => setTweak('photo_hero', v)
  })));
}
function ApBoot() {
  const ok = () => window.CaniglooDesignSystem_665af4 && window.CG_FAQ_PARTS;
  const [ready, setReady] = React.useState(!!ok());
  React.useEffect(() => {
    if (ready) return;
    const iv = setInterval(() => {
      if (ok()) {
        setReady(true);
        clearInterval(iv);
      }
    }, 60);
    return () => clearInterval(iv);
  }, [ready]);
  return ready ? /*#__PURE__*/React.createElement(ApApp, null) : null;
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(ApBoot, null));
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/a-propos/a-propos-app.jsx", error: String((e && e.message) || e) }); }

// pages/a-propos/tweaks-panel.jsx
try { (() => {
// @ds-adherence-ignore -- omelette starter scaffold (raw elements/hex/px by design)

/* BEGIN USAGE */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
// Exports (to window): useTweaks, TweaksPanel, TweakSection, TweakRow, TweakSlider,
//   TweakToggle, TweakRadio, TweakSelect, TweakText, TweakNumber, TweakColor, TweakButton.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// TweakRadio is the segmented control for 2–3 short options (auto-falls-back to
// TweakSelect past ~16/~10 chars per label); reach for TweakSelect directly when
// options are many or long. For color tweaks always curate 3-4 options rather than
// a free picker; an option can also be a whole 2–5 color palette (the stored value
// is the array). The Tweak* controls are a floor, not a ceiling — build custom
// controls inside the panel if a tweak calls for UI they don't cover.
/* END USAGE */
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children)));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/a-propos/tweaks-panel.jsx", error: String((e && e.message) || e) }); }

// pages/blog/blog-app.jsx
try { (() => {
/* Canigloo — Page Blog : sections + app.
   Réutilise le chrome du site (header/footer) exposé par ../faq/faq-parts.jsx (window.CG_FAQ_PARTS). */

const NSb = () => window.CaniglooDesignSystem_665af4 || {};
const BLOG_EASE = 'cubic-bezier(0.22,0.61,0.36,1)';
const BLOG_TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "fond": "Blanc",
  "photo_hero": true,
  "cartes": "Filets"
} /*EDITMODE-END*/;
const BLOG_BG = {
  'Blanc': '#FFFFFF',
  'Crème': '#F7F3EC'
};
function blogCardShell(cartes, hover) {
  return {
    background: '#fff',
    borderRadius: 'var(--radius-lg, 16px)',
    border: cartes === 'Ombres' ? '1px solid transparent' : '1px solid var(--line)',
    boxShadow: cartes === 'Ombres' ? hover ? '0 12px 32px rgba(15,46,58,0.12)' : '0 4px 16px rgba(15,46,58,0.06)' : 'none',
    transition: `box-shadow .25s ${BLOG_EASE}, transform .25s ${BLOG_EASE}, border-color .2s ${BLOG_EASE}`
  };
}
function scrollToEl(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 110;
  window.scrollTo({
    top,
    behavior: 'smooth'
  });
}

/* ---------- Hero ---------- */
function BlogHero({
  photo
}) {
  const {
    Button,
    Eyebrow,
    IconArrowRight
  } = NSb();
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Blog \u2014 Hero",
    style: {
      background: 'linear-gradient(180deg, var(--teal-50) 0%, transparent 100%)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-hero-grid",
    style: {
      maxWidth: 1180,
      margin: '0 auto',
      padding: photo ? '56px 24px 48px' : '64px 24px 44px',
      display: photo ? 'grid' : 'block',
      gridTemplateColumns: photo ? '1.1fr 1fr' : undefined,
      gap: 48,
      alignItems: 'center',
      textAlign: photo ? 'left' : 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: photo ? {} : {
      maxWidth: 680,
      margin: '0 auto'
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    wide: true,
    style: {
      marginBottom: 16
    }
  }, "Les guides Canigloo") : null, /*#__PURE__*/React.createElement("h1", {
    className: "blog-hero-h1",
    style: {
      fontWeight: 800,
      letterSpacing: '-1px',
      lineHeight: 1.06,
      color: 'var(--ink)',
      margin: '0 0 16px'
    }
  }, "Des conseils simples pour aider ton chien ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--teal)'
    }
  }, "quand il fait chaud.")), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 17,
      lineHeight: 1.65,
      color: 'var(--ink-soft)',
      margin: '0 0 28px',
      maxWidth: 520,
      marginLeft: photo ? 0 : 'auto',
      marginRight: photo ? 0 : 'auto'
    }
  }, "Chaleur, balades, hal\xE8tement, tapis rafra\xEEchissant, petits gestes du quotidien : ici, on t'aide \xE0 prendre soin de ton chien sans jargon, sans panique, et sans culpabilit\xE9 inutile."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 14,
      flexWrap: 'wrap',
      justifyContent: photo ? 'flex-start' : 'center'
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    iconRight: IconArrowRight ? /*#__PURE__*/React.createElement(IconArrowRight, {
      size: 18
    }) : null,
    onClick: () => scrollToEl('blog-featured')
  }, "Lire le guide canicule") : null, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline",
    size: "lg",
    onClick: () => {
      window.location.href = '/';
    }
  }, "D\xE9couvrir IceDream") : null)), photo ? /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('homepage-hero.jpg'),
    alt: "Chien allong\xE9 dans un coin frais, lumi\xE8re d'\xE9t\xE9",
    style: {
      width: '100%',
      height: 380,
      objectFit: 'cover',
      borderRadius: 'var(--radius-xl, 24px)',
      display: 'block'
    }
  }) : null));
}

/* ---------- Par où commencer ---------- */
function StartCards({
  cartes
}) {
  const Icons = NSb();
  const {
    IconArrowRight
  } = Icons;
  const data = (window.CG_BLOG_DATA || {}).start || [];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Blog \u2014 Par o\xF9 commencer"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1180,
      margin: '0 auto',
      padding: '28px 24px 10px'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 24,
      fontWeight: 800,
      letterSpacing: '-0.5px',
      color: 'var(--ink)',
      margin: '0 0 18px'
    }
  }, "Par o\xF9 commencer ?"), /*#__PURE__*/React.createElement("div", {
    className: "blog-start-grid",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 16
    }
  }, data.map(c => {
    const Ic = Icons[c.icon];
    return /*#__PURE__*/React.createElement("button", {
      key: c.title,
      onClick: () => scrollToEl('article-' + c.target),
      style: {
        ...blogCardShell(cartes),
        border: cartes === 'Ombres' ? '1px solid transparent' : '1.5px solid var(--teal-light)',
        cursor: 'pointer',
        textAlign: 'left',
        fontFamily: 'inherit',
        padding: '22px 22px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        alignItems: 'flex-start'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        width: 40,
        height: 40,
        borderRadius: 11,
        background: 'var(--teal-light)',
        color: 'var(--teal-deep)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, Ic ? /*#__PURE__*/React.createElement(Ic, {
      size: 21
    }) : null), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 17,
        fontWeight: 700,
        color: 'var(--ink)',
        letterSpacing: '-0.2px'
      }
    }, c.title), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 14,
        lineHeight: 1.58,
        color: 'var(--ink-soft)'
      }
    }, c.text), /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 14,
        fontWeight: 700,
        color: 'var(--teal)',
        marginTop: 2
      }
    }, "Lire le guide ", IconArrowRight ? /*#__PURE__*/React.createElement(IconArrowRight, {
      size: 15
    }) : '→'));
  }))));
}

/* ---------- Article mis en avant ---------- */
function FeaturedArticle({
  cartes
}) {
  const {
    Button,
    Badge
  } = NSb();
  const art = ((window.CG_BLOG_DATA || {}).articles || []).find(a => a.featured);
  if (!art) return null;
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Blog \u2014 Article mis en avant",
    id: "blog-featured"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1180,
      margin: '0 auto',
      padding: '40px 24px 10px'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 24,
      fontWeight: 800,
      letterSpacing: '-0.5px',
      color: 'var(--ink)',
      margin: '0 0 18px'
    }
  }, "Le guide \xE0 lire avant les grosses chaleurs"), /*#__PURE__*/React.createElement("article", {
    className: "blog-featured",
    style: {
      ...blogCardShell(cartes),
      display: 'grid',
      gridTemplateColumns: '1.15fr 1fr',
      overflow: 'hidden',
      alignItems: 'stretch'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: art.cover,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      minHeight: 280,
      objectFit: 'cover',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '34px 34px 30px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 14
    }
  }, Badge ? /*#__PURE__*/React.createElement(Badge, {
    tone: "teal"
  }, art.tag) : /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      fontWeight: 700,
      color: 'var(--teal-deep)',
      background: 'var(--teal-light)',
      borderRadius: 999,
      padding: '4px 12px'
    }
  }, art.tag), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 26,
      fontWeight: 800,
      letterSpacing: '-0.5px',
      lineHeight: 1.18,
      color: 'var(--ink)',
      margin: 0
    }
  }, art.title), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.65,
      color: 'var(--ink-soft)',
      margin: 0
    }
  }, art.featuredText), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 600,
      color: 'var(--muted)'
    }
  }, "Temps de lecture : ", art.time), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'auto',
      paddingTop: 6
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "md"
  }, "Lire le guide complet") : null)))));
}

/* ---------- Grille des guides ---------- */
function ArticleCard({
  art,
  cartes
}) {
  const Icons = NSb();
  const {
    IconArrowRight
  } = Icons;
  const [hover, setHover] = React.useState(false);
  const Ic = art.icon ? Icons[art.icon] : null;
  return /*#__PURE__*/React.createElement("article", {
    id: 'article-' + art.id,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: {
      ...blogCardShell(cartes, hover),
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      transform: hover ? 'translateY(-3px)' : 'none',
      scrollMarginTop: 120
    }
  }, art.cover ? /*#__PURE__*/React.createElement("img", {
    src: art.cover,
    alt: "",
    style: {
      width: '100%',
      height: 175,
      objectFit: 'cover',
      display: 'block'
    }
  }) : /*#__PURE__*/React.createElement("div", {
    style: {
      height: 175,
      background: 'linear-gradient(135deg, var(--teal-light) 0%, var(--teal-50) 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'var(--teal)'
    }
  }, Ic ? /*#__PURE__*/React.createElement(Ic, {
    size: 52
  }) : null), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '20px 22px 22px',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      flex: 1,
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '1.2px',
      color: 'var(--teal-deep)',
      background: 'var(--teal-light)',
      borderRadius: 999,
      padding: '4px 11px'
    }
  }, art.tag), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 17.5,
      fontWeight: 700,
      letterSpacing: '-0.3px',
      lineHeight: 1.3,
      color: 'var(--ink)',
      margin: 0
    }
  }, art.title), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14,
      lineHeight: 1.6,
      color: 'var(--ink-soft)',
      margin: 0
    }
  }, art.excerpt), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'auto',
      paddingTop: 8,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      fontWeight: 600,
      color: 'var(--muted)'
    }
  }, art.time, " de lecture"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => e.preventDefault(),
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      fontSize: 14,
      fontWeight: 700,
      color: 'var(--teal)',
      textDecoration: 'none'
    }
  }, "Lire l'article ", IconArrowRight ? /*#__PURE__*/React.createElement(IconArrowRight, {
    size: 15
  }) : '→'))));
}
function ArticlesGrid({
  cartes
}) {
  const articles = (window.CG_BLOG_DATA || {}).articles || [];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Blog \u2014 Tous les conseils"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1180,
      margin: '0 auto',
      padding: '44px 24px 10px'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 24,
      fontWeight: 800,
      letterSpacing: '-0.5px',
      color: 'var(--ink)',
      margin: '0 0 6px'
    }
  }, "Tous les conseils Canigloo"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15,
      color: 'var(--muted)',
      margin: '0 0 20px'
    }
  }, "Des guides courts, utiles et \xE9crits pour les ma\xEEtres qui veulent faire simple et bien."), /*#__PURE__*/React.createElement("div", {
    className: "blog-grid",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 18
    }
  }, articles.map(a => /*#__PURE__*/React.createElement(ArticleCard, {
    key: a.id,
    art: a,
    cartes: cartes
  })))));
}

/* ---------- Bloc produit discret ---------- */
function ProductBlock() {
  const {
    Button,
    IconWind,
    IconPlugOff,
    IconWash,
    IconTruck
  } = NSb();
  const benefits = [{
    icon: IconWind,
    t: "Respirant et agréable quand il fait chaud"
  }, {
    icon: IconPlugOff,
    t: 'Sans eau, sans électricité'
  }, {
    icon: IconWash,
    t: 'Lavable en machine'
  }, {
    icon: IconTruck,
    t: 'Livraison suivie 7 à 10 jours'
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Blog \u2014 Produit"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1180,
      margin: '0 auto',
      padding: '48px 24px 14px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-product",
    style: {
      background: 'var(--teal-50)',
      border: '1px solid var(--teal-light)',
      borderRadius: 'var(--radius-xl, 24px)',
      display: 'grid',
      gridTemplateColumns: '0.9fr 1.1fr',
      gap: 36,
      alignItems: 'center',
      padding: '36px 40px',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('product-icedream.png'),
    alt: "Matelas IceDream",
    style: {
      width: '100%',
      maxHeight: 300,
      objectFit: 'contain',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 27,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      lineHeight: 1.15,
      color: 'var(--ink)',
      margin: '0 0 12px'
    }
  }, "Et \xE0 la maison, il a d\xE9j\xE0 son coin frais ?"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15.5,
      lineHeight: 1.65,
      color: 'var(--ink-soft)',
      margin: '0 0 18px',
      maxWidth: 480
    }
  }, "IceDream est le matelas rafra\xEEchissant Canigloo pens\xE9 pour les chiens qui cherchent le carrelage d\xE8s que la chaleur monte. Tu le poses, il s'allonge, et toi tu souffles un peu."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '10px 18px',
      marginBottom: 22
    }
  }, benefits.map(b => /*#__PURE__*/React.createElement("span", {
    key: b.t,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 9,
      fontSize: 13.5,
      fontWeight: 600,
      color: 'var(--ink)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      color: 'var(--teal)',
      flexShrink: 0
    }
  }, b.icon ? /*#__PURE__*/React.createElement(b.icon, {
    size: 17
  }) : null), b.t))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      flexWrap: 'wrap'
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    onClick: () => {
      window.location.href = '/';
    }
  }, "Voir IceDream") : null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      fontWeight: 500,
      color: 'var(--muted)'
    }
  }, "Satisfait ou rembours\xE9 \xB7 Paiement s\xE9curis\xE9 \xB7 Marque fran\xE7aise"))))));
}

/* ---------- Capture email ---------- */
function NewsletterBlock() {
  const {
    Button,
    IconPaw
  } = NSb();
  const [email, setEmail] = React.useState('');
  const [sent, setSent] = React.useState(false);
  const [focus, setFocus] = React.useState(false);
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Blog \u2014 Newsletter"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 900,
      margin: '0 auto',
      padding: '40px 24px 80px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-news-pad",
    style: {
      background: 'linear-gradient(135deg, var(--teal) 0%, var(--teal-deep) 100%)',
      borderRadius: 'var(--radius-xl, 24px)',
      padding: '48px 48px',
      textAlign: 'center',
      color: '#fff',
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: -26,
      right: -14,
      opacity: 0.13,
      color: '#fff',
      pointerEvents: 'none'
    }
  }, IconPaw ? /*#__PURE__*/React.createElement(IconPaw, {
    size: 140
  }) : null), /*#__PURE__*/React.createElement("h2", {
    style: {
      position: 'relative',
      fontSize: 28,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      margin: '0 0 10px',
      lineHeight: 1.12
    }
  }, "Re\xE7ois la checklist chaleur Canigloo."), /*#__PURE__*/React.createElement("p", {
    style: {
      position: 'relative',
      fontSize: 15.5,
      color: 'rgba(255,255,255,0.9)',
      margin: '0 auto 24px',
      maxWidth: 520,
      lineHeight: 1.6
    }
  }, "Une checklist simple pour savoir quoi faire quand la temp\xE9rature monte : eau, balade, coin frais, signaux \xE0 surveiller."), sent ? /*#__PURE__*/React.createElement("p", {
    style: {
      position: 'relative',
      fontSize: 16,
      fontWeight: 700,
      margin: 0
    }
  }, "\uD83D\uDC3E C'est not\xE9 ! La checklist arrive dans ta bo\xEEte mail.") : /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      setSent(true);
    },
    className: "blog-news-form",
    style: {
      position: 'relative',
      display: 'flex',
      gap: 10,
      justifyContent: 'center',
      maxWidth: 480,
      margin: '0 auto'
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "email",
    required: true,
    value: email,
    onChange: e => setEmail(e.target.value),
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    placeholder: "Ton email",
    "aria-label": "Ton email",
    style: {
      flex: 1,
      minWidth: 0,
      boxSizing: 'border-box',
      height: 50,
      borderRadius: 12,
      border: `1.5px solid ${focus ? 'var(--orange)' : 'rgba(255,255,255,0.3)'}`,
      background: 'rgba(255,255,255,0.97)',
      padding: '0 16px',
      fontSize: 15,
      fontFamily: 'inherit',
      color: 'var(--ink)',
      outline: 'none',
      transition: `border-color .2s ${BLOG_EASE}`
    }
  }), Button ? /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    size: "lg"
  }, "Recevoir la checklist") : /*#__PURE__*/React.createElement("button", {
    type: "submit"
  }, "OK")), !sent ? /*#__PURE__*/React.createElement("p", {
    style: {
      position: 'relative',
      fontSize: 12.5,
      color: 'rgba(255,255,255,0.75)',
      margin: '14px 0 0'
    }
  }, "Pas de spam. Juste des conseils utiles et les nouveaut\xE9s Canigloo.") : null)));
}

/* ---------- App ---------- */
function BlogApp() {
  const P = window.CG_FAQ_PARTS;
  const [t, setTweak] = useTweaks(BLOG_TWEAK_DEFAULTS);
  const pageBg = BLOG_BG[t.fond] || '#fff';
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: pageBg,
      minHeight: '100vh',
      transition: 'background .3s'
    }
  }, /*#__PURE__*/React.createElement(P.FaqAnnouncement, null), /*#__PURE__*/React.createElement(P.FaqHeader, {
    active: "Blog"
  }), /*#__PURE__*/React.createElement(BlogHero, {
    photo: t.photo_hero
  }), /*#__PURE__*/React.createElement(StartCards, {
    cartes: t.cartes
  }), /*#__PURE__*/React.createElement(FeaturedArticle, {
    cartes: t.cartes
  }), /*#__PURE__*/React.createElement(ArticlesGrid, {
    cartes: t.cartes
  }), /*#__PURE__*/React.createElement(ProductBlock, null), /*#__PURE__*/React.createElement(NewsletterBlock, null), /*#__PURE__*/React.createElement(P.FaqFooter, null), /*#__PURE__*/React.createElement(TweaksPanel, null, /*#__PURE__*/React.createElement(TweakSection, {
    label: "Style"
  }), /*#__PURE__*/React.createElement(TweakRadio, {
    label: "Fond",
    value: t.fond,
    options: ['Blanc', 'Crème'],
    onChange: v => setTweak('fond', v)
  }), /*#__PURE__*/React.createElement(TweakRadio, {
    label: "Cartes",
    value: t.cartes,
    options: ['Filets', 'Ombres'],
    onChange: v => setTweak('cartes', v)
  }), /*#__PURE__*/React.createElement(TweakToggle, {
    label: "Photo dans le hero",
    value: t.photo_hero,
    onChange: v => setTweak('photo_hero', v)
  })));
}
function BlogBoot() {
  const [ready, setReady] = React.useState(!!(window.CaniglooDesignSystem_665af4 && window.CG_FAQ_PARTS && window.CG_BLOG_DATA));
  React.useEffect(() => {
    if (ready) return;
    const iv = setInterval(() => {
      if (window.CaniglooDesignSystem_665af4 && window.CG_FAQ_PARTS && window.CG_BLOG_DATA) {
        setReady(true);
        clearInterval(iv);
      }
    }, 60);
    return () => clearInterval(iv);
  }, [ready]);
  return ready ? /*#__PURE__*/React.createElement(BlogApp, null) : null;
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(BlogBoot, null));
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/blog/blog-app.jsx", error: String((e && e.message) || e) }); }

// pages/blog/blog-data.js
try { (() => {
/* Canigloo — Blog « Conseils chien & été ».
   Source : Structure_page_blog_Shopify_Canigloo.md (structure Yomi).
   4 articles de lancement, maillage vers IceDream. */

window.CG_BLOG_DATA = {
  articles: [{
    id: 'rafraichir',
    tag: 'Chaleur',
    title: 'Comment rafraîchir son chien : 9 astuces qui marchent vraiment',
    excerpt: "Des gestes simples pour le soulager dès aujourd'hui : eau, ombre, coin frais, horaires de balade. Sans clim, sans prise de tête.",
    time: '5 min',
    cover: null,
    icon: 'IconWind'
  }, {
    id: 'coup-de-chaleur',
    tag: 'Canicule',
    title: 'Coup de chaleur chez le chien : signes, bons réflexes et erreurs à éviter',
    excerpt: "Quoi regarder, quoi faire, et quand demander de l'aide. Le guide à lire avant les grosses chaleurs.",
    time: '8 min',
    cover: window.CG_ASSET('blog-1.png'),
    featured: true,
    featuredText: "Quand ton chien a chaud, tu n'as pas besoin d'un discours compliqué. Tu as besoin de savoir quoi regarder, quoi faire, et quand demander de l'aide."
  }, {
    id: 'symptomes',
    tag: 'Canicule',
    title: 'Symptômes du coup de chaleur chez le chien : les signes à repérer',
    excerpt: 'Halètement, fatigue, comportement inhabituel : les signaux à surveiller sans paniquer.',
    time: '4 min',
    cover: null,
    icon: 'IconShield'
  }, {
    id: 'meilleur-tapis',
    tag: 'Tapis rafraîchissant',
    title: 'Meilleur tapis rafraîchissant chien : coton respirant, avis et choix 2026',
    excerpt: 'Matière, taille, entretien, avis : comment choisir sans te faire avoir.',
    time: '6 min',
    cover: window.CG_ASSET('blog-2.png')
  }],
  start: [{
    title: "Il fait chaud aujourd'hui",
    text: 'Les gestes simples pour le soulager maintenant, sans clim et sans prise de tête.',
    target: 'rafraichir',
    icon: 'IconWind'
  }, {
    title: 'Tu veux reconnaître les signes',
    text: 'Halètement, fatigue, comportement inhabituel : les signaux à surveiller sans paniquer.',
    target: 'symptomes',
    icon: 'IconShield'
  }, {
    title: 'Tu hésites sur un tapis',
    text: 'Matière, taille, entretien, avis : comment choisir sans te faire avoir.',
    target: 'meilleur-tapis',
    icon: 'IconBed'
  }]
};
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/blog/blog-data.js", error: String((e && e.message) || e) }); }

// pages/blog/tweaks-panel.jsx
try { (() => {
// @ds-adherence-ignore -- omelette starter scaffold (raw elements/hex/px by design)

/* BEGIN USAGE */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
// Exports (to window): useTweaks, TweaksPanel, TweakSection, TweakRow, TweakSlider,
//   TweakToggle, TweakRadio, TweakSelect, TweakText, TweakNumber, TweakColor, TweakButton.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// TweakRadio is the segmented control for 2–3 short options (auto-falls-back to
// TweakSelect past ~16/~10 chars per label); reach for TweakSelect directly when
// options are many or long. For color tweaks always curate 3-4 options rather than
// a free picker; an option can also be a whole 2–5 color palette (the stored value
// is the array). The Tweak* controls are a floor, not a ceiling — build custom
// controls inside the panel if a tweak calls for UI they don't cover.
/* END USAGE */
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children)));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/blog/tweaks-panel.jsx", error: String((e && e.message) || e) }); }

// pages/contact/contact-app.jsx
try { (() => {
/* Canigloo — Page Contact : formulaire + infos + liens rapides.
   Réutilise le chrome (header/footer) de window.CG_FAQ_PARTS. */

const NSc = () => window.CaniglooDesignSystem_665af4 || {};
const CT_EASE = 'cubic-bezier(0.22,0.61,0.36,1)';
const CT_TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "fond": "Crème"
} /*EDITMODE-END*/;
const CT_BG = {
  'Blanc': '#FFFFFF',
  'Crème': '#F7F3EC',
  'Teal clair': '#F2FBFD'
};
function CtField({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--ink)'
    }
  }, label), children);
}
const CT_INPUT = {
  width: '100%',
  boxSizing: 'border-box',
  borderRadius: 11,
  border: '1.5px solid var(--line)',
  background: '#fff',
  color: 'var(--ink)',
  fontFamily: 'inherit',
  fontSize: 14.5,
  padding: '12px 14px',
  outline: 'none',
  minHeight: 46,
  transition: `border-color .2s ${CT_EASE}, box-shadow .2s ${CT_EASE}`
};
function CtForm() {
  const {
    Button
  } = NSc();
  const [sent, setSent] = React.useState(false);
  const [f, setF] = React.useState({
    nom: '',
    email: '',
    commande: '',
    sujet: 'Question produit',
    message: ''
  });
  const set = k => e => setF({
    ...f,
    [k]: e.target.value
  });
  const on = e => {
    e.target.style.borderColor = 'var(--teal)';
    e.target.style.boxShadow = '0 0 0 3px var(--teal-light)';
  };
  const off = e => {
    e.target.style.borderColor = 'var(--line)';
    e.target.style.boxShadow = 'none';
  };
  if (sent) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center',
        padding: '44px 28px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 36,
        lineHeight: 1,
        marginBottom: 12
      }
    }, "\uD83D\uDC3E"), /*#__PURE__*/React.createElement("h3", {
      style: {
        margin: '0 0 8px',
        fontSize: 20,
        fontWeight: 800,
        color: 'var(--ink)'
      }
    }, "Message bien re\xE7u", f.nom.trim() ? `, merci ${f.nom.trim().split(' ')[0]}` : '', " !"), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontSize: 14.5,
        color: 'var(--ink-soft)',
        lineHeight: 1.6
      }
    }, "Un humain te r\xE9pond sous 24 h ouvr\xE9es \u2014 promis, pas un robot.", /*#__PURE__*/React.createElement("br", null), "Pense \xE0 v\xE9rifier tes spams, au cas o\xF9."));
  }
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      setSent(true);
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ct-form-row",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(CtField, {
    label: "Ton pr\xE9nom"
  }, /*#__PURE__*/React.createElement("input", {
    required: true,
    value: f.nom,
    onChange: set('nom'),
    onFocus: on,
    onBlur: off,
    placeholder: "Camille",
    autoComplete: "name",
    style: CT_INPUT
  })), /*#__PURE__*/React.createElement(CtField, {
    label: "Ton email"
  }, /*#__PURE__*/React.createElement("input", {
    required: true,
    type: "email",
    value: f.email,
    onChange: set('email'),
    onFocus: on,
    onBlur: off,
    placeholder: "camille@email.fr",
    autoComplete: "email",
    style: CT_INPUT
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ct-form-row",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(CtField, {
    label: "Sujet"
  }, /*#__PURE__*/React.createElement("select", {
    value: f.sujet,
    onChange: set('sujet'),
    onFocus: on,
    onBlur: off,
    style: {
      ...CT_INPUT,
      cursor: 'pointer',
      appearance: 'auto'
    }
  }, /*#__PURE__*/React.createElement("option", null, "Question produit"), /*#__PURE__*/React.createElement("option", null, "Ma commande / livraison"), /*#__PURE__*/React.createElement("option", null, "Retour ou remboursement"), /*#__PURE__*/React.createElement("option", null, "Presse / partenariat"), /*#__PURE__*/React.createElement("option", null, "Autre"))), /*#__PURE__*/React.createElement(CtField, {
    label: "N\xB0 de commande (si tu en as un)"
  }, /*#__PURE__*/React.createElement("input", {
    value: f.commande,
    onChange: set('commande'),
    onFocus: on,
    onBlur: off,
    placeholder: "#1234 \u2014 optionnel",
    style: CT_INPUT
  }))), /*#__PURE__*/React.createElement(CtField, {
    label: "Ton message"
  }, /*#__PURE__*/React.createElement("textarea", {
    required: true,
    rows: 5,
    value: f.message,
    onChange: set('message'),
    onFocus: on,
    onBlur: off,
    placeholder: "Dis-nous tout. Plus tu nous en dis, plus on te r\xE9pond vite et juste.",
    style: {
      ...CT_INPUT,
      resize: 'vertical',
      minHeight: 130,
      lineHeight: 1.55
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      flexWrap: 'wrap'
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    size: "lg"
  }, "Envoyer mon message") : /*#__PURE__*/React.createElement("button", {
    type: "submit"
  }, "Envoyer"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13,
      color: 'var(--muted)'
    }
  }, "R\xE9ponse sous 24 h ouvr\xE9es.")));
}

/* ---------- Carte infos ---------- */
function CtInfoCard() {
  const {
    IconPaw,
    IconTruck,
    IconReturn,
    IconShield
  } = NSc();
  const faqLinks = [{
    t: 'Quelle taille choisir ?',
    url: '/pages/faq'
  }, {
    t: 'Suivre ma commande',
    url: '/pages/faq'
  }, {
    t: 'Faire un retour',
    url: '/pages/faq'
  }];
  return /*#__PURE__*/React.createElement("aside", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'linear-gradient(135deg, var(--teal) 0%, var(--teal-deep) 100%)',
      borderRadius: 'var(--radius-xl, 24px)',
      padding: '30px 30px 26px',
      color: '#fff',
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: -22,
      right: -12,
      opacity: 0.13,
      color: '#fff',
      pointerEvents: 'none'
    }
  }, IconPaw ? /*#__PURE__*/React.createElement(IconPaw, {
    size: 110
  }) : null), /*#__PURE__*/React.createElement("h2", {
    style: {
      position: 'relative',
      fontSize: 21,
      fontWeight: 800,
      letterSpacing: '-0.4px',
      margin: '0 0 8px'
    }
  }, "On est l\xE0, vraiment."), /*#__PURE__*/React.createElement("p", {
    style: {
      position: 'relative',
      fontSize: 14,
      lineHeight: 1.62,
      color: 'rgba(255,255,255,0.9)',
      margin: '0 0 18px'
    }
  }, "Derri\xE8re Canigloo, il y a des humains qui lisent chaque message. Pas de chatbot, pas de r\xE9ponse automatique \xE0 rallonge."), /*#__PURE__*/React.createElement("a", {
    href: "mailto:contact@canigloo.com",
    style: {
      position: 'relative',
      display: 'inline-block',
      fontSize: 15,
      fontWeight: 700,
      color: '#fff',
      textDecoration: 'underline',
      textUnderlineOffset: 4
    }
  }, "contact@canigloo.com"), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      fontSize: 12.5,
      color: 'rgba(255,255,255,0.78)',
      marginTop: 14
    }
  }, "R\xE9ponse sous 24 h ouvr\xE9es \xB7 7 j/7 en \xE9t\xE9 \uD83D\uDC3E")), /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#fff',
      border: '1px solid var(--line)',
      borderRadius: 'var(--radius-lg, 16px)',
      padding: '22px 24px'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '2px',
      color: 'var(--muted)',
      margin: '0 0 14px'
    }
  }, "R\xE9ponses imm\xE9diates"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    }
  }, faqLinks.map(l => /*#__PURE__*/React.createElement("a", {
    key: l.t,
    href: l.url,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 10,
      fontSize: 14.5,
      fontWeight: 600,
      color: 'var(--ink)',
      textDecoration: 'none',
      padding: '10px 2px',
      borderBottom: '1px solid var(--line)'
    }
  }, l.t, " ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--teal)',
      fontWeight: 700
    }
  }, "\u2192")))), /*#__PURE__*/React.createElement("a", {
    href: '/pages/faq',
    style: {
      display: 'inline-block',
      marginTop: 14,
      fontSize: 13.5,
      fontWeight: 700,
      color: 'var(--teal)',
      textDecoration: 'none'
    }
  }, "Voir toute la FAQ \u2192")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      padding: '4px 6px'
    }
  }, [{
    icon: IconShield,
    t: 'Satisfait ou remboursé'
  }, {
    icon: IconTruck,
    t: 'Livraison suivie 7–10 jours'
  }, {
    icon: IconReturn,
    t: 'Retours sans prise de tête'
  }].map(p => /*#__PURE__*/React.createElement("span", {
    key: p.t,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 9,
      fontSize: 13.5,
      fontWeight: 600,
      color: 'var(--ink-soft)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      color: 'var(--teal)'
    }
  }, p.icon ? /*#__PURE__*/React.createElement(p.icon, {
    size: 17
  }) : null), p.t))));
}

/* ---------- App ---------- */
function CtApp() {
  const P = window.CG_FAQ_PARTS;
  const {
    Eyebrow
  } = NSc();
  const [t, setTweak] = useTweaks(CT_TWEAK_DEFAULTS);
  const pageBg = CT_BG[t.fond] || CT_BG['Crème'];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: pageBg,
      minHeight: '100vh',
      transition: 'background .3s'
    }
  }, /*#__PURE__*/React.createElement(P.FaqAnnouncement, null), /*#__PURE__*/React.createElement(P.FaqHeader, {
    active: "Contact"
  }), /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Contact \u2014 Hero"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 760,
      margin: '0 auto',
      textAlign: 'center',
      padding: '56px 24px 40px'
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    wide: true,
    style: {
      marginBottom: 14
    }
  }, "Contact") : null, /*#__PURE__*/React.createElement("h1", {
    className: "ct-hero-h1",
    style: {
      fontWeight: 800,
      letterSpacing: '-1px',
      lineHeight: 1.06,
      color: 'var(--ink)',
      margin: '0 0 14px'
    }
  }, "Une question ? On t'\xE9coute."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 16.5,
      lineHeight: 1.6,
      color: 'var(--ink-soft)',
      margin: '0 auto',
      maxWidth: 520
    }
  }, "Produit, commande, retour, ou juste envie de nous montrer une photo de ton chien sur son IceDream \u2014 \xE9cris-nous."))), /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Contact \u2014 Formulaire"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ct-grid",
    style: {
      maxWidth: 1040,
      margin: '0 auto',
      padding: '0 24px 80px',
      display: 'grid',
      gridTemplateColumns: '1.5fr 1fr',
      gap: 28,
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#fff',
      border: '1px solid var(--line)',
      borderRadius: 'var(--radius-xl, 24px)',
      padding: '34px 36px'
    },
    className: "ct-form-pad"
  }, /*#__PURE__*/React.createElement(CtForm, null)), /*#__PURE__*/React.createElement(CtInfoCard, null))), /*#__PURE__*/React.createElement(P.FaqFooter, null), /*#__PURE__*/React.createElement(TweaksPanel, null, /*#__PURE__*/React.createElement(TweakSection, {
    label: "Style"
  }), /*#__PURE__*/React.createElement(TweakRadio, {
    label: "Fond",
    value: t.fond,
    options: ['Blanc', 'Crème', 'Teal clair'],
    onChange: v => setTweak('fond', v)
  })));
}
function CtBoot() {
  const ok = () => window.CaniglooDesignSystem_665af4 && window.CG_FAQ_PARTS;
  const [ready, setReady] = React.useState(!!ok());
  React.useEffect(() => {
    if (ready) return;
    const iv = setInterval(() => {
      if (ok()) {
        setReady(true);
        clearInterval(iv);
      }
    }, 60);
    return () => clearInterval(iv);
  }, [ready]);
  return ready ? /*#__PURE__*/React.createElement(CtApp, null) : null;
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(CtBoot, null));
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/contact/contact-app.jsx", error: String((e && e.message) || e) }); }

// pages/contact/tweaks-panel.jsx
try { (() => {
// @ds-adherence-ignore -- omelette starter scaffold (raw elements/hex/px by design)

/* BEGIN USAGE */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
// Exports (to window): useTweaks, TweaksPanel, TweakSection, TweakRow, TweakSlider,
//   TweakToggle, TweakRadio, TweakSelect, TweakText, TweakNumber, TweakColor, TweakButton.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// TweakRadio is the segmented control for 2–3 short options (auto-falls-back to
// TweakSelect past ~16/~10 chars per label); reach for TweakSelect directly when
// options are many or long. For color tweaks always curate 3-4 options rather than
// a free picker; an option can also be a whole 2–5 color palette (the stored value
// is the array). The Tweak* controls are a floor, not a ceiling — build custom
// controls inside the panel if a tweak calls for UI they don't cover.
/* END USAGE */
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children)));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/contact/tweaks-panel.jsx", error: String((e && e.message) || e) }); }

// pages/faq/faq-app.jsx
try { (() => {
/* Canigloo — Page FAQ : assemblage + Tweaks. */

const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "version": "Centré",
  "fond": "Crème",
  "cartes": "Filets",
  "densite": "Aéré",
  "categories": true
} /*EDITMODE-END*/;
const FAQ_BG = {
  'Blanc': '#FFFFFF',
  'Crème': '#F7F3EC',
  'Teal clair': '#F2FBFD'
};
const FAQ_DENS = {
  'Aéré': {
    sumPad: '18px 22px',
    ansPad: '0 22px 20px',
    qSize: 16,
    aSize: 14.5,
    gap: 12,
    groupGap: 44
  },
  'Compact': {
    sumPad: '13px 18px',
    ansPad: '0 18px 15px',
    qSize: 15,
    aSize: 14,
    gap: 8,
    groupGap: 32
  }
};
function normalize(s) {
  return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function filterGroups(groups, query) {
  const q = normalize(query.trim());
  if (!q) return groups;
  return groups.map(g => ({
    ...g,
    items: g.items.filter(it => normalize(it.q + ' ' + it.a.join(' ')).includes(q))
  })).filter(g => g.items.length > 0);
}
function FaqApp() {
  const P = window.CG_FAQ_PARTS;
  const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
  const [query, setQuery] = React.useState('');
  const [openKey, setOpenKey] = React.useState(null);
  const [activeId, setActiveId] = React.useState('produit');
  const refMap = React.useRef({});
  const dens = FAQ_DENS[t.densite] || FAQ_DENS['Aéré'];
  const pageBg = FAQ_BG[t.fond] || FAQ_BG['Crème'];
  const allGroups = window.CG_FAQ_DATA || [];
  const groups = filterGroups(allGroups, query);
  const searching = query.trim().length > 0;
  const useCategories = t.categories && !searching;
  const sidebarMode = t.version === 'Sidebar' && useCategories;
  const nbResults = groups.reduce((n, g) => n + g.items.length, 0);

  /* Groupe actif au scroll */
  React.useEffect(() => {
    if (!useCategories) return;
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        let current = groups[0] && groups[0].id;
        for (const g of groups) {
          const el = refMap.current[g.id];
          if (el && el.getBoundingClientRect().top <= 170) current = g.id;
        }
        if (current) setActiveId(current);
      });
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      cancelAnimationFrame(raf);
    };
  }, [useCategories, t.version, query]);
  const jumpTo = id => {
    const el = refMap.current[id];
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 130;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  };

  /* Liste plate quand catégories désactivées ou recherche active */
  const flatGroup = {
    id: 'tout',
    label: 'Toutes les questions',
    icon: 'IconPaw',
    items: groups.flatMap(g => g.items.map(it => ({
      ...it,
      _gid: g.id
    })))
  };
  const groupsColumn = /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: dens.groupGap,
      minWidth: 0
    }
  }, searching ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '0 0 -8px',
      fontSize: 13.5,
      fontWeight: 600,
      color: 'var(--muted)'
    }
  }, nbResults > 0 ? `${nbResults} réponse${nbResults > 1 ? 's' : ''} pour « ${query.trim()} »` : '') : null, (useCategories ? groups : [flatGroup]).map(g => /*#__PURE__*/React.createElement(P.CategoryGroup, {
    key: g.id,
    group: g,
    openKey: openKey,
    setOpenKey: setOpenKey,
    dens: dens,
    cardStyle: t.cartes,
    showHeading: useCategories,
    refMap: refMap
  })), nbResults === 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      padding: '40px 20px',
      background: '#fff',
      border: '1px dashed var(--line)',
      borderRadius: 16
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '0 0 6px',
      fontSize: 16,
      fontWeight: 700,
      color: 'var(--ink)'
    }
  }, "Aucune r\xE9ponse pour \xAB ", query.trim(), " \xBB"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 14,
      color: 'var(--muted)'
    }
  }, "Essaie un autre mot, ou \xE9cris-nous juste en dessous \u2014 on te r\xE9pond vite.")) : null);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: pageBg,
      minHeight: '100vh',
      transition: 'background .3s'
    }
  }, /*#__PURE__*/React.createElement(P.FaqAnnouncement, null), /*#__PURE__*/React.createElement(P.FaqHeader, null), /*#__PURE__*/React.createElement(P.FaqHero, {
    query: query,
    onQuery: setQuery,
    pageBg: pageBg
  }), /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "FAQ \u2014 Questions"
  }, sidebarMode ? /*#__PURE__*/React.createElement(P.FContainer, {
    style: {
      maxWidth: 1080,
      paddingBottom: 40
    }
  }, /*#__PURE__*/React.createElement(P.CategoryChips, {
    className: "faq-chips faq-chips-mobile-only",
    groups: groups,
    activeId: activeId,
    onJump: jumpTo,
    pageBg: pageBg
  }), /*#__PURE__*/React.createElement("div", {
    className: "faq-grid",
    style: {
      display: 'grid',
      gridTemplateColumns: '250px minmax(0,1fr)',
      gap: 44,
      alignItems: 'start',
      paddingTop: 8
    }
  }, /*#__PURE__*/React.createElement(P.CategorySidebar, {
    groups: groups,
    activeId: activeId,
    onJump: jumpTo
  }), groupsColumn)) : /*#__PURE__*/React.createElement(P.FContainer, {
    style: {
      maxWidth: 820,
      paddingBottom: 40
    }
  }, useCategories ? /*#__PURE__*/React.createElement(P.CategoryChips, {
    className: "faq-chips",
    groups: groups,
    activeId: activeId,
    onJump: jumpTo,
    pageBg: pageBg
  }) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: useCategories ? 14 : 0
    }
  }, groupsColumn))), /*#__PURE__*/React.createElement(P.ContactCard, null), /*#__PURE__*/React.createElement(P.FaqFooter, null), /*#__PURE__*/React.createElement(TweaksPanel, null, /*#__PURE__*/React.createElement(TweakSection, {
    label: "Version"
  }), /*#__PURE__*/React.createElement(TweakRadio, {
    label: "Layout",
    value: t.version,
    options: ['Centré', 'Sidebar'],
    onChange: v => setTweak('version', v)
  }), /*#__PURE__*/React.createElement(TweakToggle, {
    label: "Cat\xE9gories",
    value: t.categories,
    onChange: v => setTweak('categories', v)
  }), /*#__PURE__*/React.createElement(TweakSection, {
    label: "Style"
  }), /*#__PURE__*/React.createElement(TweakRadio, {
    label: "Fond",
    value: t.fond,
    options: ['Blanc', 'Crème', 'Teal clair'],
    onChange: v => setTweak('fond', v)
  }), /*#__PURE__*/React.createElement(TweakRadio, {
    label: "Cartes",
    value: t.cartes,
    options: ['Filets', 'Ombres'],
    onChange: v => setTweak('cartes', v)
  }), /*#__PURE__*/React.createElement(TweakRadio, {
    label: "Densit\xE9",
    value: t.densite,
    options: ['Aéré', 'Compact'],
    onChange: v => setTweak('densite', v)
  })));
}
function FaqBoot() {
  const [ready, setReady] = React.useState(!!(window.CaniglooDesignSystem_665af4 && window.CG_FAQ_PARTS));
  React.useEffect(() => {
    if (ready) return;
    const iv = setInterval(() => {
      if (window.CaniglooDesignSystem_665af4 && window.CG_FAQ_PARTS) {
        setReady(true);
        clearInterval(iv);
      }
    }, 60);
    return () => clearInterval(iv);
  }, [ready]);
  return ready ? /*#__PURE__*/React.createElement(FaqApp, null) : null;
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(FaqBoot, null));
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/faq/faq-app.jsx", error: String((e && e.message) || e) }); }

// pages/faq/faq-data.js
try { (() => {
/* Canigloo — contenu de la page FAQ.
   Voix de marque : tutoiement, direct, honnête, jamais alarmiste.
   ⚠️ Les infos opérationnelles (durée de garantie, email, moyens de paiement)
   sont à confirmer par le marchand avant mise en ligne. */

window.CG_FAQ_DATA = [{
  id: 'produit',
  label: 'Le produit',
  icon: 'IconBed',
  items: [{
    q: 'Comment fonctionne IceDream ?',
    a: ["IceDream est un matelas en coton respirant. Le tissu laisse circuler l'air en permanence et n'emmagasine pas la chaleur du corps — contrairement à un coussin, un panier ou un canapé.", "Ton chien s'allonge, l'air circule, il se pose. Pas d'eau, pas d'électricité, rien à recharger."]
  }, {
    q: "C'est un tapis réfrigérant avec du gel ?",
    a: ["Non, et on préfère être clairs là-dessus : IceDream ne contient ni gel, ni eau. C'est du coton respirant, tissé pour ne pas retenir la chaleur.", "On ne te promet pas du froid glacial — on te promet un coin frais qui le reste, sans recharge, sans fuite, sans mauvaise surprise."]
  }, {
    q: "Est-ce qu'il reste frais longtemps ?",
    a: ["Oui, parce qu'il n'a rien à « décharger » : le coton reste respirant en permanence, il ne retient simplement pas la chaleur comme un textile épais.", "Pour un effet maximal, pose-le dans un endroit aéré, à l'ombre — idéalement sur du carrelage ou du parquet."]
  }, {
    q: "Mon chien va-t-il l'utiliser ?",
    a: ["La plupart des chiens adoptent très vite un coin frais et doux à eux, surtout les jours de chaleur. Petit conseil : installe-le à l'endroit où il aime déjà se poser.", "Et si vraiment il n'en veut pas, tu es couvert par la garantie satisfait ou remboursé. Zéro risque pour toi."]
  }, {
    q: 'Convient-il aux chiots et aux chiens âgés ?',
    a: ["Oui. Le coton est doux, sans odeur et sans produit ajouté — il convient à tous les âges. Les chiens âgés, qui supportent souvent moins bien la chaleur, sont même ceux qui en profitent le plus."]
  }]
}, {
  id: 'tailles',
  label: 'Tailles & entretien',
  icon: 'IconWash',
  items: [{
    q: 'Quelle taille choisir ?',
    a: ["La règle est simple : ton chien doit pouvoir s'allonger en entier, confortablement."],
    sizes: [{
      t: 'S',
      d: '45 × 35 cm',
      ex: 'Chihuahua, Yorkshire, petit terrier'
    }, {
      t: 'M',
      d: '55 × 45 cm',
      ex: 'Beagle, Cocker, Bouledogue français'
    }, {
      t: 'L',
      d: '76 × 58 cm',
      ex: 'Labrador, Berger australien, Golden'
    }],
    after: 'Entre deux tailles ? Prends la plus grande, il te dira merci.'
  }, {
    q: 'Comment le nettoyer ?',
    a: ['En machine, tout simplement. Tu le laves, tu le sèches, il repart pour un tour. Zéro entretien compliqué.']
  }, {
    q: 'Où le placer pour un effet maximal ?',
    a: ["Dans un endroit aéré et à l'ombre : un couloir, près d'une fenêtre entrouverte, sur le carrelage de la cuisine. Évite la couverture épaisse en dessous — elle bloquerait la circulation de l'air."]
  }, {
    q: 'Résiste-t-il aux griffes ?',
    a: ["Le coton est tissé serré et supporte très bien un usage normal — s'allonger, gratter un peu, tourner trois fois avant de se poser.", "Si ton chien est un grand mâchouilleur, garde un œil dessus les premiers jours. Et si quelque chose ne va pas, écris-nous : on trouve toujours une solution."]
  }]
}, {
  id: 'livraison',
  label: 'Livraison',
  icon: 'IconTruck',
  items: [{
    q: 'Quels sont les délais de livraison ?',
    a: ["Livraison suivie en 7 à 10 jours, partout en France. C'est promis."]
  }, {
    q: 'Comment suivre ma commande ?',
    a: ["Dès l'expédition, tu reçois un email avec ton numéro de suivi. Tu peux suivre ton colis pas à pas, jusqu'à ta porte."]
  }, {
    q: 'Mon colis traîne, on fait quoi ?',
    a: ["Ça arrive rarement, mais ça arrive. Écris-nous avec ton numéro de commande : on le localise, et s'il est vraiment perdu, on t'en renvoie un. Tu ne restes jamais sans réponse."]
  }]
}, {
  id: 'retours',
  label: 'Retours & garantie',
  icon: 'IconReturn',
  items: [{
    q: "Et si mon chien ne l'adopte pas ?",
    a: ["Laisse-lui quelques jours — les chiens aiment prendre leurs marques. S'il n'en veut vraiment pas, on te rembourse : c'est ça, la garantie satisfait ou remboursé.", 'Pas de formulaire à rallonge, pas de question piège.']
  }, {
    q: 'Comment faire un retour ?',
    a: ["Écris-nous, on t'explique tout en deux lignes et on s'occupe du reste. Tu n'as rien à imprimer, rien à deviner."]
  }, {
    q: 'Le produit est arrivé abîmé, on fait quoi ?',
    a: ["Envoie-nous une photo avec ton numéro de commande. On t'en renvoie un neuf ou on te rembourse — c'est toi qui choisis."]
  }]
}, {
  id: 'paiement',
  label: 'Paiement sécurisé',
  icon: 'IconLock',
  items: [{
    q: 'Quels moyens de paiement acceptez-vous ?',
    a: ['Carte bancaire (Visa, Mastercard), PayPal, Apple Pay et Google Pay.']
  }, {
    q: 'Le paiement est-il sécurisé ?',
    a: ["Oui. Toutes les transactions passent par la plateforme sécurisée de Shopify, avec chiffrement SSL et 3D Secure. On ne voit jamais tes informations bancaires — personne chez nous n'y a accès."]
  }]
}];
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/faq/faq-data.js", error: String((e && e.message) || e) }); }

// pages/faq/faq-parts.jsx
try { (() => {
/* Canigloo — Page FAQ (app).
   Lit le design system via window.CaniglooDesignSystem_665af4 (bundle compilé). */

const NSf = () => window.CaniglooDesignSystem_665af4 || {};
const MAXWF = 1180;
const EASE = 'cubic-bezier(0.22,0.61,0.36,1)';
function FContainer({
  children,
  style,
  className
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: {
      maxWidth: MAXWF,
      margin: '0 auto',
      padding: '0 24px',
      ...style
    }
  }, children);
}

/* ---------- Annonce + Header (réplique navbar Shopiweb Premium de la boutique) ---------- */
const CG_ANNOUNCEMENTS = ['🐾 Marque française · Livraison suivie 7 à 10 jours · Satisfait ou remboursé', '🇫🇷 Ton chien mérite un été parfait.'];
function AnnChevron({
  dir
}) {
  return /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    style: {
      transform: dir === 'prev' ? 'rotate(180deg)' : 'none'
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }));
}
function FaqAnnouncement() {
  const [idx, setIdx] = React.useState(0);
  React.useEffect(() => {
    const iv = setInterval(() => setIdx(i => (i + 1) % CG_ANNOUNCEMENTS.length), 5000);
    return () => clearInterval(iv);
  }, []);
  const go = d => setIdx(i => (i + d + CG_ANNOUNCEMENTS.length) % CG_ANNOUNCEMENTS.length);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--ink)',
      color: '#fff',
      padding: '12px 16px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 600,
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => go(-1),
    "aria-label": "Annonce pr\xE9c\xE9dente",
    style: {
      background: 'none',
      border: 'none',
      color: 'rgba(255,255,255,0.7)',
      cursor: 'pointer',
      display: 'inline-flex',
      padding: 4,
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement(AnnChevron, {
    dir: "prev"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      textAlign: 'center',
      fontSize: 13,
      fontWeight: 500,
      letterSpacing: '.2px',
      minHeight: 20
    }
  }, CG_ANNOUNCEMENTS[idx]), /*#__PURE__*/React.createElement("button", {
    onClick: () => go(1),
    "aria-label": "Annonce suivante",
    style: {
      background: 'none',
      border: 'none',
      color: 'rgba(255,255,255,0.7)',
      cursor: 'pointer',
      display: 'inline-flex',
      padding: 4,
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement(AnnChevron, {
    dir: "next"
  }))));
}

/* Menu réel de la boutique */
const CG_MAIN_MENU = [{
  title: 'Accueil',
  url: '/'
}, {
  title: 'IceDream',
  url: '/pages/produit'
}, {
  title: 'FAQ',
  url: '/pages/faq'
}, {
  title: 'Blog',
  url: '/pages/blog'
}, {
  title: 'À propos',
  url: '/pages/a-propos'
}, {
  title: 'Contact',
  url: '/pages/contact'
}];
function PersonIcon({
  size = 19
}) {
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  }));
}
function NavIcon({
  children,
  label,
  onClick,
  badge
}) {
  return /*#__PURE__*/React.createElement("button", {
    "aria-label": label,
    onClick: onClick,
    style: {
      position: 'relative',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink-soft)',
      display: 'inline-flex',
      padding: '8px 12px'
    }
  }, children, badge != null ? /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 2,
      right: 2,
      background: 'var(--orange)',
      color: '#fff',
      fontSize: 10.5,
      fontWeight: 700,
      borderRadius: 999,
      minWidth: 17,
      height: 17,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 4px'
    }
  }, badge) : null);
}
function FaqHeader({
  active = 'FAQ'
}) {
  const {
    Button,
    IconCart,
    IconMenu,
    IconArrowRight
  } = NSf();
  const [menuOpen, setMenuOpen] = React.useState(false);
  return /*#__PURE__*/React.createElement("header", {
    style: {
      position: 'sticky',
      top: 0,
      zIndex: 30,
      background: '#fff',
      boxShadow: '0 .125rem .25rem rgba(15,46,58,0.075)',
      padding: '12px 0'
    }
  }, /*#__PURE__*/React.createElement(FContainer, {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Menu",
    className: "faq-burger",
    onClick: () => setMenuOpen(!menuOpen),
    style: {
      display: 'none',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink)',
      padding: 8,
      marginLeft: -8
    }
  }, IconMenu ? /*#__PURE__*/React.createElement(IconMenu, {
    size: 24
  }) : '≡'), /*#__PURE__*/React.createElement("a", {
    href: '/',
    className: "faq-logo",
    style: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('canigloo-logo-principal.png'),
    alt: "Canigloo",
    style: {
      height: 46,
      width: 'auto',
      display: 'block'
    }
  })), /*#__PURE__*/React.createElement("nav", {
    className: "faq-nav",
    style: {
      display: 'flex',
      gap: 2,
      justifyContent: 'center',
      flex: 1
    }
  }, CG_MAIN_MENU.map(l => /*#__PURE__*/React.createElement("a", {
    key: l.title,
    href: l.url,
    style: {
      whiteSpace: 'nowrap',
      fontSize: 15,
      fontWeight: l.title === active ? 700 : 600,
      color: l.title === active ? 'var(--teal)' : 'var(--ink)',
      textDecoration: 'none',
      padding: '8px 12px',
      borderRadius: 8
    }
  }, l.title))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      marginLeft: 'auto',
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "faq-connexion",
    style: {
      whiteSpace: 'nowrap',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 7,
      fontSize: 14.5,
      fontWeight: 600,
      color: 'var(--ink)',
      textDecoration: 'none',
      padding: '8px 10px'
    }
  }, /*#__PURE__*/React.createElement(PersonIcon, null), " Connexion"), /*#__PURE__*/React.createElement("span", {
    className: "faq-header-cta",
    style: {
      margin: '0 4px'
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "sm",
    iconRight: IconArrowRight ? /*#__PURE__*/React.createElement(IconArrowRight, {
      size: 16
    }) : null,
    onClick: () => {
      window.location.href = '/';
    }
  }, "Commander") : null), /*#__PURE__*/React.createElement("button", {
    "aria-label": "Panier",
    style: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink)',
      display: 'inline-flex',
      padding: 8,
      marginRight: -8
    }
  }, IconCart ? /*#__PURE__*/React.createElement(IconCart, {
    size: 23
  }) : '🛒'))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateRows: menuOpen ? '1fr' : '0fr',
      transition: `grid-template-rows .3s ${EASE}`,
      position: 'absolute',
      left: 0,
      right: 0,
      top: '100%',
      background: '#fff',
      boxShadow: menuOpen ? '0 18px 30px rgba(15,46,58,0.15)' : 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--ink)',
      color: '#fff',
      padding: '13px 22px',
      fontSize: 15,
      fontWeight: 700
    }
  }, "Menu"), /*#__PURE__*/React.createElement("nav", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      padding: '8px 0 4px'
    }
  }, CG_MAIN_MENU.map(l => /*#__PURE__*/React.createElement("a", {
    key: l.title,
    href: l.url,
    onClick: () => setMenuOpen(false),
    style: {
      fontSize: 15.5,
      fontWeight: l.title === active ? 700 : 500,
      color: l.title === active ? 'var(--teal)' : 'var(--ink)',
      textDecoration: 'none',
      padding: '13px 22px',
      borderBottom: '1px solid var(--line)'
    }
  }, l.title)), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: () => setMenuOpen(false),
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      fontSize: 15.5,
      fontWeight: 500,
      color: 'var(--ink)',
      textDecoration: 'none',
      padding: '13px 22px'
    }
  }, /*#__PURE__*/React.createElement(PersonIcon, null), " Connexion")))));
}

/* ---------- Hero + recherche ---------- */
function SearchIcon({
  size = 18
}) {
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.5",
    y1: "16.5",
    x2: "21",
    y2: "21"
  }));
}
function FaqHero({
  query,
  onQuery,
  pageBg
}) {
  const {
    Eyebrow
  } = NSf();
  const [focus, setFocus] = React.useState(false);
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "FAQ \u2014 Hero",
    style: {
      background: `linear-gradient(180deg, var(--teal-light) -40%, ${pageBg} 100%)`
    }
  }, /*#__PURE__*/React.createElement(FContainer, {
    style: {
      textAlign: 'center',
      padding: '58px 24px 38px',
      maxWidth: 760
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    wide: true,
    style: {
      marginBottom: 14
    }
  }, "FAQ") : null, /*#__PURE__*/React.createElement("h1", {
    className: "faq-hero-h1",
    style: {
      fontWeight: 800,
      letterSpacing: '-1px',
      lineHeight: 1.06,
      color: 'var(--ink)',
      margin: '0 0 14px'
    }
  }, "Les questions qu'on nous pose."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 16.5,
      lineHeight: 1.6,
      color: 'var(--muted)',
      margin: '0 auto 26px',
      maxWidth: 520
    }
  }, "Et nos vraies r\xE9ponses \u2014 sans jargon, sans d\xE9tour. Si tu ne trouves pas la tienne, \xE9cris-nous, on te r\xE9pond vite."), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      maxWidth: 520,
      margin: '0 auto'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      left: 18,
      top: '50%',
      transform: 'translateY(-50%)',
      color: focus ? 'var(--teal)' : 'var(--muted)',
      display: 'inline-flex',
      transition: `color .2s ${EASE}`
    }
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), /*#__PURE__*/React.createElement("input", {
    type: "search",
    value: query,
    onChange: e => onQuery(e.target.value),
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    placeholder: "Cherche un mot : taille, lavage, retour\u2026",
    "aria-label": "Rechercher dans la FAQ",
    style: {
      width: '100%',
      boxSizing: 'border-box',
      height: 52,
      borderRadius: 999,
      border: `1.5px solid ${focus ? 'var(--teal)' : 'var(--line)'}`,
      background: '#fff',
      padding: '0 20px 0 48px',
      fontSize: 15.5,
      fontFamily: 'inherit',
      color: 'var(--ink)',
      outline: 'none',
      boxShadow: focus ? '0 0 0 4px var(--teal-light)' : '0 2px 10px rgba(15,46,58,0.05)',
      transition: `box-shadow .2s ${EASE}, border-color .2s ${EASE}`
    }
  }))));
}

/* ---------- Question / réponse ---------- */
function SizeRows({
  sizes
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      margin: '12px 0'
    }
  }, sizes.map(s => /*#__PURE__*/React.createElement("div", {
    key: s.t,
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      background: 'var(--teal-50)',
      border: '1px solid var(--line)',
      borderRadius: 10,
      padding: '9px 14px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 30,
      height: 30,
      borderRadius: 8,
      background: 'var(--teal)',
      color: '#fff',
      fontWeight: 700,
      fontSize: 14,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    }
  }, s.t), /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 700,
      color: 'var(--ink)',
      fontSize: 14.5,
      whiteSpace: 'nowrap'
    }
  }, s.d), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--muted)',
      fontSize: 13.5
    }
  }, s.ex))));
}
function QAItem({
  item,
  open,
  onToggle,
  dens,
  cardStyle
}) {
  const {
    IconChevronDown
  } = NSf();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#fff',
      borderRadius: 'var(--radius-md, 12px)',
      overflow: 'hidden',
      border: cardStyle === 'Ombres' ? '1px solid transparent' : `1px solid ${open ? 'var(--teal)' : 'var(--line)'}`,
      boxShadow: cardStyle === 'Ombres' ? open ? '0 10px 30px rgba(15,46,58,0.10)' : '0 4px 16px rgba(15,46,58,0.06)' : 'none',
      transition: `border-color .2s ${EASE}, box-shadow .25s ${EASE}`
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onToggle,
    "aria-expanded": open,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      width: '100%',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      textAlign: 'left',
      fontFamily: 'inherit',
      padding: dens.sumPad,
      fontSize: dens.qSize,
      fontWeight: 600,
      color: 'var(--ink)',
      minHeight: 48
    }
  }, /*#__PURE__*/React.createElement("span", null, item.q), /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--teal)',
      display: 'inline-flex',
      flexShrink: 0,
      transform: open ? 'rotate(180deg)' : 'none',
      transition: `transform .25s ${EASE}`
    }
  }, IconChevronDown ? /*#__PURE__*/React.createElement(IconChevronDown, {
    size: 20
  }) : '⌄')), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateRows: open ? '1fr' : '0fr',
      transition: `grid-template-rows .3s ${EASE}`
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: dens.ansPad,
      fontSize: dens.aSize,
      lineHeight: 1.62,
      color: 'var(--ink-soft)'
    }
  }, item.a.map((p, i) => /*#__PURE__*/React.createElement("p", {
    key: i,
    style: {
      margin: i === 0 ? 0 : '10px 0 0'
    }
  }, p)), item.sizes ? /*#__PURE__*/React.createElement(SizeRows, {
    sizes: item.sizes
  }) : null, item.after ? /*#__PURE__*/React.createElement("p", {
    style: {
      margin: '10px 0 0',
      fontWeight: 600,
      color: 'var(--teal-deep)'
    }
  }, item.after) : null))));
}

/* ---------- Groupe de catégorie ---------- */
function CategoryGroup({
  group,
  openKey,
  setOpenKey,
  dens,
  cardStyle,
  showHeading,
  refMap
}) {
  const Icons = NSf();
  const Ic = Icons[group.icon];
  return /*#__PURE__*/React.createElement("div", {
    ref: el => {
      if (refMap) refMap.current[group.id] = el;
    },
    style: {
      scrollMarginTop: 140
    }
  }, showHeading ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      margin: '0 0 14px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 38,
      height: 38,
      borderRadius: 10,
      background: 'var(--teal-light)',
      color: 'var(--teal-deep)',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    }
  }, Ic ? /*#__PURE__*/React.createElement(Ic, {
    size: 20
  }) : null), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 21,
      fontWeight: 800,
      letterSpacing: '-0.4px',
      color: 'var(--ink)',
      margin: 0
    }
  }, group.label), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      fontWeight: 600,
      color: 'var(--muted)',
      background: '#fff',
      border: '1px solid var(--line)',
      borderRadius: 999,
      padding: '3px 10px'
    }
  }, group.items.length)) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: dens.gap
    }
  }, group.items.map(item => {
    const k = group.id + '::' + item.q;
    return /*#__PURE__*/React.createElement(QAItem, {
      key: k,
      item: item,
      open: openKey === k,
      onToggle: () => setOpenKey(openKey === k ? null : k),
      dens: dens,
      cardStyle: cardStyle
    });
  })));
}

/* ---------- Chips & sidebar de navigation ---------- */
function CategoryChips({
  groups,
  activeId,
  onJump,
  pageBg,
  className
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: {
      position: 'sticky',
      top: 84,
      zIndex: 20,
      background: `color-mix(in srgb, ${pageBg} 88%, transparent)`,
      backdropFilter: 'blur(8px)',
      padding: '12px 0',
      display: 'flex',
      gap: 8,
      overflowX: 'auto',
      justifyContent: 'safe center',
      scrollbarWidth: 'none'
    }
  }, groups.map(g => {
    const active = g.id === activeId;
    return /*#__PURE__*/React.createElement("button", {
      key: g.id,
      onClick: () => onJump(g.id),
      style: {
        flexShrink: 0,
        border: active ? '1.5px solid var(--teal)' : '1.5px solid var(--line)',
        borderRadius: 999,
        cursor: 'pointer',
        background: active ? 'var(--teal)' : '#fff',
        color: active ? '#fff' : 'var(--ink-soft)',
        fontFamily: 'inherit',
        fontSize: 13.5,
        fontWeight: 600,
        padding: '9px 16px',
        minHeight: 38,
        transition: `all .2s ${EASE}`
      }
    }, g.label);
  }));
}
function CategorySidebar({
  groups,
  activeId,
  onJump
}) {
  const Icons = NSf();
  return /*#__PURE__*/React.createElement("aside", {
    className: "faq-sidebar",
    style: {
      position: 'sticky',
      top: 116,
      alignSelf: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11.5,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '2.5px',
      color: 'var(--muted)',
      margin: '4px 0 12px 14px'
    }
  }, "Cat\xE9gories"), /*#__PURE__*/React.createElement("nav", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    }
  }, groups.map(g => {
    const active = g.id === activeId;
    const Ic = Icons[g.icon];
    return /*#__PURE__*/React.createElement("button", {
      key: g.id,
      onClick: () => onJump(g.id),
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 11,
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        fontFamily: 'inherit',
        background: active ? '#fff' : 'transparent',
        borderRadius: 11,
        padding: '11px 14px',
        minHeight: 44,
        boxShadow: active ? '0 2px 10px rgba(15,46,58,0.07)' : 'none',
        transition: `all .2s ${EASE}`
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: active ? 'var(--teal)' : 'var(--muted)',
        display: 'inline-flex'
      }
    }, Ic ? /*#__PURE__*/React.createElement(Ic, {
      size: 19
    }) : null), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 14.5,
        fontWeight: active ? 700 : 500,
        color: active ? 'var(--ink)' : 'var(--ink-soft)',
        flex: 1
      }
    }, g.label), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 12,
        fontWeight: 600,
        color: 'var(--muted)'
      }
    }, g.items.length));
  })));
}

/* ---------- Bloc contact ---------- */
function ContactField({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      textAlign: 'left',
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13,
      fontWeight: 600,
      color: 'rgba(255,255,255,0.92)'
    }
  }, label), children);
}
const CONTACT_INPUT_STYLE = {
  width: '100%',
  boxSizing: 'border-box',
  borderRadius: 11,
  border: '1.5px solid rgba(255,255,255,0.25)',
  background: 'rgba(255,255,255,0.97)',
  color: 'var(--ink)',
  fontFamily: 'inherit',
  fontSize: 14.5,
  padding: '12px 14px',
  outline: 'none',
  minHeight: 46,
  transition: `border-color .2s ${EASE}, box-shadow .2s ${EASE}`
};
function ContactForm() {
  const {
    Button
  } = NSf();
  const [sent, setSent] = React.useState(false);
  const [fields, setFields] = React.useState({
    nom: '',
    email: '',
    sujet: 'Question produit',
    message: ''
  });
  const set = k => e => setFields({
    ...fields,
    [k]: e.target.value
  });
  const focusOn = e => {
    e.target.style.borderColor = 'var(--orange)';
    e.target.style.boxShadow = '0 0 0 3px rgba(234,88,12,0.25)';
  };
  const focusOff = e => {
    e.target.style.borderColor = 'rgba(255,255,255,0.25)';
    e.target.style.boxShadow = 'none';
  };
  if (sent) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        background: 'rgba(255,255,255,0.12)',
        border: '1px solid rgba(255,255,255,0.25)',
        borderRadius: 16,
        padding: '34px 28px',
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 34,
        lineHeight: 1,
        marginBottom: 10
      }
    }, "\uD83D\uDC3E"), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: '0 0 6px',
        fontSize: 18,
        fontWeight: 700,
        color: '#fff'
      }
    }, "Message bien re\xE7u, merci ", fields.nom.trim() ? fields.nom.trim().split(' ')[0] : '', " !"), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontSize: 14.5,
        color: 'rgba(255,255,255,0.85)'
      }
    }, "Un humain te r\xE9pond sous 24 h ouvr\xE9es \u2014 promis, pas un robot."));
  }
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      setSent(true);
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "faq-form-row",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement(ContactField, {
    label: "Ton pr\xE9nom"
  }, /*#__PURE__*/React.createElement("input", {
    required: true,
    value: fields.nom,
    onChange: set('nom'),
    onFocus: focusOn,
    onBlur: focusOff,
    placeholder: "Camille",
    autoComplete: "name",
    style: CONTACT_INPUT_STYLE
  })), /*#__PURE__*/React.createElement(ContactField, {
    label: "Ton email"
  }, /*#__PURE__*/React.createElement("input", {
    required: true,
    type: "email",
    value: fields.email,
    onChange: set('email'),
    onFocus: focusOn,
    onBlur: focusOff,
    placeholder: "camille@email.fr",
    autoComplete: "email",
    style: CONTACT_INPUT_STYLE
  }))), /*#__PURE__*/React.createElement(ContactField, {
    label: "Sujet"
  }, /*#__PURE__*/React.createElement("select", {
    value: fields.sujet,
    onChange: set('sujet'),
    onFocus: focusOn,
    onBlur: focusOff,
    style: {
      ...CONTACT_INPUT_STYLE,
      cursor: 'pointer',
      appearance: 'auto'
    }
  }, /*#__PURE__*/React.createElement("option", null, "Question produit"), /*#__PURE__*/React.createElement("option", null, "Ma commande / livraison"), /*#__PURE__*/React.createElement("option", null, "Retour ou remboursement"), /*#__PURE__*/React.createElement("option", null, "Autre"))), /*#__PURE__*/React.createElement(ContactField, {
    label: "Ton message"
  }, /*#__PURE__*/React.createElement("textarea", {
    required: true,
    rows: 4,
    value: fields.message,
    onChange: set('message'),
    onFocus: focusOn,
    onBlur: focusOff,
    placeholder: "Dis-nous tout \u2014 et si \xE7a concerne une commande, ajoute son num\xE9ro.",
    style: {
      ...CONTACT_INPUT_STYLE,
      resize: 'vertical',
      minHeight: 110,
      lineHeight: 1.55
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      flexWrap: 'wrap',
      marginTop: 2
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    size: "lg"
  }, "Envoyer mon message") : /*#__PURE__*/React.createElement("button", {
    type: "submit"
  }, "Envoyer"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13,
      color: 'rgba(255,255,255,0.8)'
    }
  }, "R\xE9ponse sous 24 h ouvr\xE9es \xB7 ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:contact@canigloo.com",
    style: {
      color: '#fff',
      fontWeight: 600,
      textDecoration: 'underline',
      textUnderlineOffset: 3
    }
  }, "contact@canigloo.com"))));
}
function ContactCard() {
  const {
    IconPaw,
    IconShield,
    IconReturn,
    IconTruck
  } = NSf();
  const points = [{
    icon: IconShield,
    t: 'Satisfait ou remboursé'
  }, {
    icon: IconTruck,
    t: 'Livraison suivie 7–10 jours'
  }, {
    icon: IconReturn,
    t: 'Retours sans prise de tête'
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "FAQ \u2014 Contact"
  }, /*#__PURE__*/React.createElement(FContainer, {
    style: {
      padding: '26px 24px 80px',
      maxWidth: 900
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "faq-contact-pad",
    style: {
      background: 'linear-gradient(135deg, var(--teal) 0%, var(--teal-deep) 100%)',
      borderRadius: 'var(--radius-xl, 24px)',
      padding: '52px 48px',
      color: '#fff',
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: -26,
      right: -14,
      opacity: 0.13,
      color: '#fff',
      pointerEvents: 'none'
    }
  }, IconPaw ? /*#__PURE__*/React.createElement(IconPaw, {
    size: 140
  }) : null), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      textAlign: 'center',
      marginBottom: 30
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 30,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      margin: '0 0 10px',
      lineHeight: 1.1
    }
  }, "Tu n'as pas trouv\xE9 ta r\xE9ponse ?"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 16,
      color: 'rgba(255,255,255,0.9)',
      margin: 0
    }
  }, "\xC9cris-nous, un humain te r\xE9pond \u2014 pas un robot.")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      maxWidth: 560,
      margin: '0 auto'
    }
  }, /*#__PURE__*/React.createElement(ContactForm, null)), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      gap: 22,
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginTop: 30
    }
  }, points.map(p => /*#__PURE__*/React.createElement("span", {
    key: p.t,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 7,
      fontSize: 13,
      fontWeight: 500,
      color: 'rgba(255,255,255,0.85)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      color: '#FFD9C2'
    }
  }, p.icon ? /*#__PURE__*/React.createElement(p.icon, {
    size: 16
  }) : null), p.t))))));
}

/* ---------- Footer ---------- */
function FaqFooter() {
  const cols = [{
    h: 'Boutique',
    items: ['IceDream', 'Comment ça marche', 'Avis', 'À propos']
  }, {
    h: 'Aide',
    items: ['FAQ', 'Contact', 'Livraison', 'Retours & remboursements']
  }, {
    h: 'Légal',
    items: ['Mentions légales', 'CGV', 'Confidentialité']
  }];
  return /*#__PURE__*/React.createElement("footer", {
    "data-screen-label": "Footer",
    style: {
      background: 'var(--ink)',
      color: 'rgba(255,255,255,0.75)'
    }
  }, /*#__PURE__*/React.createElement(FContainer, {
    style: {
      padding: '52px 24px 30px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "faq-footer-grid",
    style: {
      display: 'grid',
      gridTemplateColumns: '1.4fr 1fr 1fr 1fr',
      gap: 32
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      marginBottom: 12
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('canigloo-favicon.png'),
    alt: "",
    style: {
      width: 38,
      height: 38,
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 21,
      fontWeight: 700,
      letterSpacing: '-0.4px',
      color: '#fff'
    }
  }, "Canigloo")), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14,
      color: 'rgba(255,255,255,0.6)',
      margin: 0,
      maxWidth: 240
    }
  }, "Ton chien m\xE9rite un \xE9t\xE9 parfait. Marque fran\xE7aise.")), cols.map(c => /*#__PURE__*/React.createElement("div", {
    key: c.h
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '1.5px',
      color: '#fff',
      marginBottom: 14
    }
  }, c.h), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 9
    }
  }, c.items.map(it => /*#__PURE__*/React.createElement("a", {
    key: it,
    href: "#",
    style: {
      fontSize: 13.5,
      color: 'rgba(255,255,255,0.7)',
      textDecoration: 'none'
    }
  }, it)))))), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: '1px solid rgba(255,255,255,0.12)',
      marginTop: 34,
      paddingTop: 20,
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 12,
      fontSize: 12.5,
      color: 'rgba(255,255,255,0.55)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "\xA9 2026 Canigloo \xB7 Paris \uD83C\uDDEB\uD83C\uDDF7"), /*#__PURE__*/React.createElement("span", null, "TikTok \xB7 Instagram \xB7 Facebook \u2192 @canigloo"))));
}
window.CG_FAQ_PARTS = {
  FaqAnnouncement,
  FaqHeader,
  FaqHero,
  QAItem,
  CategoryGroup,
  CategoryChips,
  CategorySidebar,
  ContactCard,
  FaqFooter,
  FContainer
};
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/faq/faq-parts.jsx", error: String((e && e.message) || e) }); }

// pages/faq/tweaks-panel.jsx
try { (() => {
// @ds-adherence-ignore -- omelette starter scaffold (raw elements/hex/px by design)

/* BEGIN USAGE */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
// Exports (to window): useTweaks, TweaksPanel, TweakSection, TweakRow, TweakSlider,
//   TweakToggle, TweakRadio, TweakSelect, TweakText, TweakNumber, TweakColor, TweakButton.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// TweakRadio is the segmented control for 2–3 short options (auto-falls-back to
// TweakSelect past ~16/~10 chars per label); reach for TweakSelect directly when
// options are many or long. For color tweaks always curate 3-4 options rather than
// a free picker; an option can also be a whole 2–5 color palette (the stored value
// is the array). The Tweak* controls are a floor, not a ceiling — build custom
// controls inside the panel if a tweak calls for UI they don't cover.
/* END USAGE */
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children)));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/faq/tweaks-panel.jsx", error: String((e && e.message) || e) }); }

// pages/produit/produit-app.jsx
try { (() => {
/* Canigloo — Page produit IceDream : assemblage + Tweaks. */

const PDP_TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "promo": true,
  "lots": true,
  "barre_sticky": true,
  "comparatif": true
} /*EDITMODE-END*/;
function PdpApp() {
  const P = window.CG_FAQ_PARTS;
  const PP = window.CG_PDP_PARTS;
  const S = window.CG_PDP_SECTIONS;
  const [t, setTweak] = useTweaks(PDP_TWEAK_DEFAULTS);
  const [size, setSize] = React.useState('M');
  const [color, setColor] = React.useState('bleu');
  const [qty, setQty] = React.useState(1);
  const [bundle, setBundle] = React.useState(1);
  const [unitColors, setUnitColors] = React.useState(['bleu']);
  const [added, setAdded] = React.useState(false);
  const [barVisible, setBarVisible] = React.useState(false);

  /* Ajuste la liste des coloris quand la taille du lot change */
  React.useEffect(() => {
    setUnitColors(prev => {
      const arr = prev.slice(0, bundle);
      while (arr.length < bundle) arr.push(arr[arr.length - 1] || color);
      return arr;
    });
  }, [bundle]);
  const setUnitColor = (i, c) => {
    setUnitColors(prev => prev.map((v, idx) => idx === i ? c : v));
    setColor(c); /* la galerie suit le dernier coloris touché */
  };
  const onAdd = () => {
    setAdded(true);
    setTimeout(() => setAdded(false), 2200);
  };
  const state = {
    size,
    setSize,
    color,
    setColor,
    qty,
    setQty,
    bundle,
    setBundle,
    unitColors,
    setUnitColor,
    added,
    onAdd
  };
  const colorObj = PP.P_COLORS.find(c => c.id === color);

  /* La barre sticky apparaît quand la buy box est passée */
  React.useEffect(() => {
    if (!t.barre_sticky) {
      setBarVisible(false);
      return;
    }
    const onScroll = () => {
      const el = document.getElementById('pdp-buybox');
      if (!el) return;
      setBarVisible(el.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [t.barre_sticky]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#fff',
      minHeight: '100vh'
    }
  }, /*#__PURE__*/React.createElement(P.FaqAnnouncement, null), /*#__PURE__*/React.createElement(P.FaqHeader, {
    active: "IceDream"
  }), /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Produit \u2014 Achat"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-grid",
    style: {
      maxWidth: 1180,
      margin: '0 auto',
      padding: '34px 24px 0',
      display: 'grid',
      gridTemplateColumns: '1.05fr 1fr',
      gap: 52,
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(PP.ProductGallery, {
    colorObj: colorObj
  }), /*#__PURE__*/React.createElement(PP.BuyBox, {
    state: state,
    promo: t.promo,
    lots: t.lots
  }))), /*#__PURE__*/React.createElement(S.SocialProofStrip, null), /*#__PURE__*/React.createElement(S.PdpHowItWorks, null), t.comparatif ? /*#__PURE__*/React.createElement(S.PdpCompare, null) : null, /*#__PURE__*/React.createElement(S.PdpReviews, null), /*#__PURE__*/React.createElement(S.PdpGuarantee, null), /*#__PURE__*/React.createElement(S.PdpFaq, null), /*#__PURE__*/React.createElement(P.FaqFooter, null), t.barre_sticky ? /*#__PURE__*/React.createElement(PP.StickyBuyBar, {
    state: state,
    promo: t.promo,
    lots: t.lots,
    visible: barVisible
  }) : null, /*#__PURE__*/React.createElement(TweaksPanel, null, /*#__PURE__*/React.createElement(TweakSection, {
    label: "Conversion"
  }), /*#__PURE__*/React.createElement(TweakToggle, {
    label: "Prix barr\xE9 (-30 %)",
    value: t.promo,
    onChange: v => setTweak('promo', v)
  }), /*#__PURE__*/React.createElement(TweakToggle, {
    label: "Offres en lot (-10 % / -20 %)",
    value: t.lots,
    onChange: v => setTweak('lots', v)
  }), /*#__PURE__*/React.createElement(TweakToggle, {
    label: "Barre d'achat sticky",
    value: t.barre_sticky,
    onChange: v => setTweak('barre_sticky', v)
  }), /*#__PURE__*/React.createElement(TweakToggle, {
    label: "Comparatif vs tapis gel",
    value: t.comparatif,
    onChange: v => setTweak('comparatif', v)
  })));
}
function PdpBoot() {
  const ok = () => window.CaniglooDesignSystem_665af4 && window.CG_FAQ_PARTS && window.CG_PDP_PARTS && window.CG_PDP_SECTIONS;
  const [ready, setReady] = React.useState(!!ok());
  React.useEffect(() => {
    if (ready) return;
    const iv = setInterval(() => {
      if (ok()) {
        setReady(true);
        clearInterval(iv);
      }
    }, 60);
    return () => clearInterval(iv);
  }, [ready]);
  return ready ? /*#__PURE__*/React.createElement(PdpApp, null) : null;
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(PdpBoot, null));
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/produit/produit-app.jsx", error: String((e && e.message) || e) }); }

// pages/produit/produit-parts.jsx
try { (() => {
/* Canigloo — Page produit IceDream : galerie + buy box + barre sticky.
   Réutilise le chrome (header/footer) de window.CG_FAQ_PARTS. */

const NSp = () => window.CaniglooDesignSystem_665af4 || {};
const P_EASE = 'cubic-bezier(0.22,0.61,0.36,1)';
const P_SIZES = [{
  id: 'S',
  label: 'S',
  dim: '45 × 35 cm',
  ex: 'Chihuahua, Yorkshire',
  price: 29.99
}, {
  id: 'M',
  label: 'M',
  dim: '55 × 45 cm',
  ex: 'Beagle, Bouledogue fr.',
  price: 39.99
}, {
  id: 'L',
  label: 'L',
  dim: '76 × 58 cm',
  ex: 'Labrador, Golden',
  price: 54.99
}];
const P_COLORS = [{
  id: 'bleu',
  label: 'Bleu glacier',
  hex: '#7FD4E8',
  img: window.CG_ASSET('product-icedream.png')
}, {
  id: 'rose',
  label: 'Rose givré',
  hex: '#F4B8D0',
  img: window.CG_ASSET('variante-rose.png')
}];
const P_LIFESTYLE = [window.CG_ASSET('product-2.png'), window.CG_ASSET('product-3.png')];
function pEuro(n) {
  return n.toFixed(2).replace('.', ',') + ' €';
}
function pDeliveryWindow() {
  const fmt = d => d.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long'
  });
  const a = new Date();
  a.setDate(a.getDate() + 7);
  const b = new Date();
  b.setDate(b.getDate() + 10);
  return `${fmt(a)} – ${fmt(b)}`;
}

/* ---------- Galerie ---------- */
function ProductGallery({
  colorObj
}) {
  const {
    Badge
  } = NSp();
  const imgs = [colorObj.img, ...P_LIFESTYLE];
  const [idx, setIdx] = React.useState(0);
  React.useEffect(() => {
    setIdx(0);
  }, [colorObj.id]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      position: 'sticky',
      top: 110,
      alignSelf: 'start'
    },
    className: "pdp-gallery"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      borderRadius: 'var(--radius-xl, 24px)',
      overflow: 'hidden',
      background: 'var(--cream)',
      aspectRatio: '1 / 1'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: imgs[idx],
    alt: `Matelas IceDream — ${colorObj.label}`,
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 16,
      left: 16,
      display: 'flex',
      gap: 8
    }
  }, Badge ? /*#__PURE__*/React.createElement(Badge, {
    tone: "accent"
  }, "Best-seller") : null, Badge ? /*#__PURE__*/React.createElement(Badge, {
    tone: "solid"
  }, "Marque fran\xE7aise") : null)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 10
    }
  }, imgs.map((src, i) => /*#__PURE__*/React.createElement("button", {
    key: src + i,
    onClick: () => setIdx(i),
    "aria-label": `Photo ${i + 1}`,
    style: {
      width: 72,
      height: 72,
      borderRadius: 12,
      overflow: 'hidden',
      cursor: 'pointer',
      padding: 0,
      background: 'var(--cream)',
      border: i === idx ? '2px solid var(--teal)' : '2px solid var(--line)',
      transition: `border-color .15s ${P_EASE}`
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  })))));
}

/* ---------- Accordéons d'infos ---------- */
function InfoAccordion() {
  const {
    IconChevronDown
  } = NSp();
  const [open, setOpen] = React.useState(-1);
  const rows = [{
    t: 'Matière & fabrication',
    d: "Coton respirant tissé serré, sans gel, sans eau, sans produit ajouté. Le tissu laisse circuler l'air en permanence et ne retient pas la chaleur du corps — contrairement à un coussin ou un panier classique."
  }, {
    t: 'Entretien',
    d: 'Lavable en machine. Tu le laves, tu le sèches, il repart pour un tour. Zéro entretien compliqué.'
  }, {
    t: 'Livraison & retours',
    d: "Livraison suivie en 7 à 10 jours partout en France, numéro de suivi envoyé par email dès l'expédition. Retours simples : tu nous écris, on s'occupe du reste."
  }];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: '1px solid var(--line)',
      marginTop: 4
    }
  }, rows.map((r, i) => {
    const isOpen = open === i;
    return /*#__PURE__*/React.createElement("div", {
      key: r.t,
      style: {
        borderBottom: '1px solid var(--line)'
      }
    }, /*#__PURE__*/React.createElement("button", {
      onClick: () => setOpen(isOpen ? -1 : i),
      "aria-expanded": isOpen,
      style: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 14,
        padding: '15px 2px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        fontFamily: 'inherit'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 14.5,
        fontWeight: 700,
        color: 'var(--ink)'
      }
    }, r.t), /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'var(--teal)',
        display: 'inline-flex',
        flexShrink: 0,
        transform: isOpen ? 'rotate(180deg)' : 'none',
        transition: `transform .2s ${P_EASE}`
      }
    }, IconChevronDown ? /*#__PURE__*/React.createElement(IconChevronDown, {
      size: 18
    }) : '⌄')), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'grid',
        gridTemplateRows: isOpen ? '1fr' : '0fr',
        transition: `grid-template-rows .25s ${P_EASE}`
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        overflow: 'hidden'
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        margin: '0 0 16px',
        padding: '0 2px',
        fontSize: 14,
        lineHeight: 1.62,
        color: 'var(--ink-soft)'
      }
    }, r.d))));
  }));
}

/* ---------- Offres en lot ---------- */
const P_BUNDLES = [{
  n: 1,
  disc: 0,
  label: '1 matelas',
  note: null
}, {
  n: 2,
  disc: 0.10,
  label: '2 matelas',
  note: 'Le plus choisi',
  sub: 'Un pour le salon, un pour la terrasse'
}, {
  n: 3,
  disc: 0.20,
  label: '3 matelas',
  note: 'Meilleure offre',
  sub: 'Ou à partager entre copains de balade'
}];
function pBundleTotal(unit, b) {
  return unit * b.n * (1 - b.disc);
}
function BundleSelector({
  unit,
  bundle,
  setBundle,
  unitColors,
  setUnitColor
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--ink)',
      marginBottom: 8
    }
  }, "Quantit\xE9 ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, "\u2014 \xE9conomise en prenant un lot")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, P_BUNDLES.map(b => {
    const active = bundle === b.n;
    const total = pBundleTotal(unit, b);
    const full = unit * b.n;
    return /*#__PURE__*/React.createElement("div", {
      key: b.n,
      role: "radio",
      "aria-checked": active,
      tabIndex: 0,
      onClick: () => setBundle(b.n),
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setBundle(b.n);
        }
      },
      style: {
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        fontFamily: 'inherit',
        cursor: 'pointer',
        border: active ? '2px solid var(--teal)' : '2px solid var(--line)',
        borderRadius: 14,
        padding: '13px 16px',
        background: active ? 'var(--teal-50)' : '#fff',
        position: 'relative',
        transition: `all .15s ${P_EASE}`
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 14
      }
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true",
      style: {
        width: 20,
        height: 20,
        borderRadius: '50%',
        flexShrink: 0,
        border: active ? '6px solid var(--teal)' : '2px solid var(--line)',
        background: '#fff',
        boxSizing: 'border-box',
        transition: `border .15s ${P_EASE}`
      }
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        minWidth: 0,
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 15,
        fontWeight: 800,
        color: 'var(--ink)'
      }
    }, b.label), b.disc > 0 ? /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 11.5,
        fontWeight: 800,
        color: '#fff',
        background: 'var(--orange)',
        borderRadius: 999,
        padding: '3px 10px',
        letterSpacing: '.3px'
      }
    }, "\u2212", Math.round(b.disc * 100), " %") : null, b.note ? /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 11,
        fontWeight: 700,
        color: 'var(--teal-deep)',
        background: 'var(--teal-light)',
        borderRadius: 999,
        padding: '3px 10px'
      }
    }, b.note) : null), b.sub ? /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        fontSize: 12,
        color: 'var(--muted)',
        marginTop: 3
      }
    }, b.sub) : null), /*#__PURE__*/React.createElement("span", {
      style: {
        textAlign: 'right',
        flexShrink: 0
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        fontSize: 16,
        fontWeight: 800,
        color: active ? 'var(--teal-deep)' : 'var(--ink)'
      }
    }, pEuro(total)), b.disc > 0 ? /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        fontSize: 12,
        color: 'var(--muted)'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        textDecoration: 'line-through'
      }
    }, pEuro(full)), " \xB7 ", pEuro(total / b.n), " / matelas") : null)), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'grid',
        gridTemplateRows: active && b.n > 1 ? '1fr' : '0fr',
        transition: `grid-template-rows .25s ${P_EASE}`
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        overflow: 'hidden'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 7,
        paddingTop: 12,
        marginTop: 12,
        borderTop: '1px dashed var(--teal)'
      }
    }, Array.from({
      length: b.n
    }).map((_, i) => {
      const current = unitColors[i] || P_COLORS[0].id;
      const currentObj = P_COLORS.find(c => c.id === current) || P_COLORS[0];
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        style: {
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          background: '#fff',
          border: '1px solid var(--line)',
          borderRadius: 11,
          padding: '7px 12px'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 13,
          fontWeight: 700,
          color: 'var(--ink)',
          minWidth: 72
        }
      }, "Matelas ", i + 1), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          gap: 8
        }
      }, P_COLORS.map(c => {
        const sel = c.id === current;
        return /*#__PURE__*/React.createElement("button", {
          key: c.id,
          onClick: e => {
            e.stopPropagation();
            setUnitColor(i, c.id);
          },
          "aria-label": `Matelas ${i + 1} — ${c.label}`,
          title: c.label,
          style: {
            width: 30,
            height: 30,
            borderRadius: '50%',
            cursor: 'pointer',
            background: c.hex,
            padding: 0,
            border: '2px solid #fff',
            boxShadow: sel ? '0 0 0 2.5px var(--teal)' : '0 0 0 1.5px var(--line)',
            transition: `box-shadow .15s ${P_EASE}`
          }
        });
      })), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          color: 'var(--muted)',
          marginLeft: 'auto'
        }
      }, currentObj.label));
    })))));
  })));
}

/* ---------- Buy box ---------- */
function BuyBox({
  state,
  promo,
  lots
}) {
  const {
    Button,
    Badge,
    Rating,
    IconCheck,
    IconLock,
    IconTruck,
    IconShield,
    IconPlus,
    IconMinus,
    IconWind,
    IconPlugOff,
    IconWash
  } = NSp();
  const {
    size,
    setSize,
    color,
    setColor,
    qty,
    setQty,
    bundle,
    setBundle,
    unitColors,
    setUnitColor,
    added,
    onAdd
  } = state;
  const sizeObj = P_SIZES.find(s => s.id === size);
  const colorObj = P_COLORS.find(c => c.id === color);
  const bundleObj = P_BUNDLES.find(b => b.n === bundle) || P_BUNDLES[0];
  const atcTotal = lots ? pBundleTotal(sizeObj.price, bundleObj) : sizeObj.price * qty;
  const bullets = [{
    icon: IconWind,
    t: 'Coton respirant qui ne retient pas la chaleur'
  }, {
    icon: IconPlugOff,
    t: 'Sans gel, sans eau, sans électricité — zéro recharge'
  }, {
    icon: IconWash,
    t: 'Lavable en machine, sèche vite'
  }];
  return /*#__PURE__*/React.createElement("div", {
    id: "pdp-buybox"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      marginBottom: 10
    }
  }, Rating ? /*#__PURE__*/React.createElement(Rating, {
    value: 5,
    size: 16
  }) : null, /*#__PURE__*/React.createElement("a", {
    href: "#pdp-avis",
    onClick: e => {
      e.preventDefault();
      const el = document.getElementById('pdp-avis');
      if (el) window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 90,
        behavior: 'smooth'
      });
    },
    style: {
      fontSize: 13,
      fontWeight: 600,
      color: 'var(--muted)',
      textDecoration: 'underline',
      textUnderlineOffset: 3
    }
  }, "4,9 / 5 \u2014 voir les avis")), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: 32,
      fontWeight: 800,
      letterSpacing: '-0.7px',
      lineHeight: 1.08,
      color: 'var(--ink)',
      margin: '0 0 10px'
    }
  }, "IceDream \u2014 le matelas rafra\xEEchissant qu'il va adopter."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.6,
      color: 'var(--ink-soft)',
      margin: '0 0 16px'
    }
  }, "Le coin frais en coton respirant pour les chiens qui cherchent le carrelage d\xE8s que la chaleur monte."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      marginBottom: 18
    }
  }, bullets.map(b => /*#__PURE__*/React.createElement("span", {
    key: b.t,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 9,
      fontSize: 14,
      fontWeight: 500,
      color: 'var(--ink)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      color: 'var(--teal)',
      flexShrink: 0
    }
  }, b.icon ? /*#__PURE__*/React.createElement(b.icon, {
    size: 17
  }) : null), b.t))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'baseline',
      gap: 10,
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 32,
      fontWeight: 800,
      color: 'var(--ink)'
    }
  }, pEuro(sizeObj.price)), promo ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 15,
      color: 'var(--muted)',
      textDecoration: 'line-through'
    }
  }, pEuro(sizeObj.price * 1.4)) : null, promo && Badge ? /*#__PURE__*/React.createElement(Badge, {
    tone: "orange",
    size: "sm"
  }, "-30 % \xE9t\xE9") : null), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--ink)',
      marginBottom: 8
    }
  }, "Taille ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, "\u2014 il doit pouvoir s'allonger en entier")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 10
    }
  }, P_SIZES.map(s => {
    const active = s.id === size;
    return /*#__PURE__*/React.createElement("button", {
      key: s.id,
      onClick: () => setSize(s.id),
      style: {
        padding: '11px 8px 10px',
        borderRadius: 12,
        cursor: 'pointer',
        fontFamily: 'inherit',
        textAlign: 'center',
        border: active ? '2px solid var(--teal)' : '2px solid var(--line)',
        background: active ? 'var(--teal-50)' : '#fff',
        transition: `all .15s ${P_EASE}`
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 15,
        fontWeight: 800,
        color: active ? 'var(--teal-deep)' : 'var(--ink)'
      }
    }, s.label, " \xB7 ", pEuro(s.price)), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 11.5,
        fontWeight: 600,
        color: 'var(--ink-soft)',
        marginTop: 3
      }
    }, s.dim), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 11,
        color: 'var(--muted)',
        marginTop: 1
      }
    }, s.ex));
  }))), !(lots && bundleObj.n > 1) ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 22
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--ink)',
      marginBottom: 8
    }
  }, "Coloris ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, "\u2014 ", colorObj.label)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 10
    }
  }, P_COLORS.map(c => {
    const active = c.id === color;
    return /*#__PURE__*/React.createElement("button", {
      key: c.id,
      onClick: () => setColor(c.id),
      "aria-label": c.label,
      title: c.label,
      style: {
        width: 40,
        height: 40,
        borderRadius: '50%',
        cursor: 'pointer',
        background: c.hex,
        padding: 0,
        border: '2px solid #fff',
        boxShadow: active ? '0 0 0 2.5px var(--teal)' : '0 0 0 1.5px var(--line)',
        transition: `box-shadow .15s ${P_EASE}`
      }
    });
  }))) : null, lots ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BundleSelector, {
    unit: sizeObj.price,
    bundle: bundle,
    setBundle: setBundle,
    unitColors: unitColors,
    setUnitColor: setUnitColor
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 14
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    block: true,
    onClick: onAdd
  }, added ? '✓ Ajouté au panier' : `Ajouter au panier · ${pEuro(atcTotal)}`) : null)) : /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 12,
      alignItems: 'stretch',
      marginBottom: 14
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      border: '1.5px solid var(--line)',
      borderRadius: 12,
      overflow: 'hidden',
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => setQty(Math.max(1, qty - 1)),
    "aria-label": "Moins",
    style: {
      padding: '0 13px',
      height: '100%',
      minHeight: 50,
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink)',
      display: 'flex',
      alignItems: 'center'
    }
  }, IconMinus ? /*#__PURE__*/React.createElement(IconMinus, {
    size: 16
  }) : '−'), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 30,
      textAlign: 'center',
      fontSize: 15.5,
      fontWeight: 700,
      color: 'var(--ink)'
    }
  }, qty), /*#__PURE__*/React.createElement("button", {
    onClick: () => setQty(qty + 1),
    "aria-label": "Plus",
    style: {
      padding: '0 13px',
      height: '100%',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink)',
      display: 'flex',
      alignItems: 'center'
    }
  }, IconPlus ? /*#__PURE__*/React.createElement(IconPlus, {
    size: 16
  }) : '+')), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    block: true,
    onClick: onAdd
  }, added ? '✓ Ajouté au panier' : `Ajouter au panier · ${pEuro(atcTotal)}`) : null)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 9,
      background: 'var(--teal-50)',
      border: '1px solid var(--teal-light)',
      borderRadius: 12,
      padding: '11px 14px',
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      color: 'var(--teal-deep)',
      flexShrink: 0
    }
  }, IconTruck ? /*#__PURE__*/React.createElement(IconTruck, {
    size: 18
  }) : null), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13.5,
      color: 'var(--ink)'
    }
  }, "Commande aujourd'hui, ", /*#__PURE__*/React.createElement("strong", null, "livr\xE9 entre le ", pDeliveryWindow()), " \u2014 suivi par email.")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 16,
      flexWrap: 'wrap',
      fontSize: 12.5,
      color: 'var(--muted)',
      fontWeight: 600,
      marginBottom: 18
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--success, #0E9F6E)',
      display: 'inline-flex'
    }
  }, IconCheck ? /*#__PURE__*/React.createElement(IconCheck, {
    size: 15
  }) : '✓'), "Satisfait ou rembours\xE9"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--teal)',
      display: 'inline-flex'
    }
  }, IconLock ? /*#__PURE__*/React.createElement(IconLock, {
    size: 15
  }) : null), "Paiement s\xE9curis\xE9"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--teal)',
      display: 'inline-flex'
    }
  }, IconShield ? /*#__PURE__*/React.createElement(IconShield, {
    size: 15
  }) : null), "Marque fran\xE7aise")), /*#__PURE__*/React.createElement(InfoAccordion, null));
}

/* ---------- Barre d'achat sticky (apparaît après la buy box) ---------- */
function StickyBuyBar({
  state,
  promo,
  lots,
  visible
}) {
  const {
    Button
  } = NSp();
  const {
    size,
    qty,
    bundle,
    onAdd,
    added
  } = state;
  const sizeObj = P_SIZES.find(s => s.id === size);
  const bundleObj = P_BUNDLES.find(b => b.n === bundle) || P_BUNDLES[0];
  const total = lots ? pBundleTotal(sizeObj.price, bundleObj) : sizeObj.price * qty;
  const colorCounts = {};
  if (lots && bundleObj.n > 1) {
    for (let i = 0; i < bundleObj.n; i++) {
      const c = state.unitColors[i] || P_COLORS[0].id;
      colorCounts[c] = (colorCounts[c] || 0) + 1;
    }
  }
  const colorSummary = Object.entries(colorCounts).map(([id, n]) => `${n}× ${(P_COLORS.find(c => c.id === id) || {}).label}`).join(' · ');
  const barLabel = lots && bundleObj.n > 1 ? `IceDream · ${sizeObj.label} × ${bundleObj.n} (−${Math.round(bundleObj.disc * 100)} %)` : `IceDream · ${sizeObj.label} (${sizeObj.dim})`;
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": !visible,
    style: {
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 40,
      background: '#fff',
      borderTop: '1px solid var(--line)',
      boxShadow: '0 -8px 28px rgba(15,46,58,0.10)',
      transform: visible ? 'translateY(0)' : 'translateY(110%)',
      transition: `transform .3s ${P_EASE}`,
      padding: '10px 0 calc(10px + env(safe-area-inset-bottom, 0px))'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 1180,
      margin: '0 auto',
      padding: '0 20px',
      display: 'flex',
      alignItems: 'center',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('product-icedream.png'),
    alt: "",
    className: "pdp-bar-thumb",
    style: {
      width: 46,
      height: 46,
      borderRadius: 10,
      objectFit: 'cover',
      background: 'var(--cream)',
      flexShrink: 0
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0,
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 14,
      fontWeight: 700,
      color: 'var(--ink)',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, barLabel), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      color: 'var(--muted)',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, pEuro(total), " ", lots && bundleObj.disc > 0 ? /*#__PURE__*/React.createElement("span", {
    style: {
      textDecoration: 'line-through',
      margin: '0 4px'
    }
  }, pEuro(sizeObj.price * bundleObj.n)) : promo ? /*#__PURE__*/React.createElement("span", {
    style: {
      textDecoration: 'line-through',
      margin: '0 4px'
    }
  }, pEuro(sizeObj.price * 1.4)) : null, colorSummary ? ` · ${colorSummary}` : '')), Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "md",
    onClick: onAdd
  }, added ? '✓ Ajouté' : `Ajouter · ${pEuro(total)}`) : null));
}
window.CG_PDP_PARTS = {
  ProductGallery,
  BuyBox,
  StickyBuyBar,
  P_SIZES,
  P_COLORS,
  P_BUNDLES,
  pEuro
};
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/produit/produit-parts.jsx", error: String((e && e.message) || e) }); }

// pages/produit/produit-sections.jsx
try { (() => {
/* Canigloo — Page produit IceDream : sections de réassurance et conversion (sous la buy box). */

const NSps = () => window.CaniglooDesignSystem_665af4 || {};
function PdpContainer({
  children,
  style,
  className,
  id
}) {
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: className,
    style: {
      maxWidth: 1180,
      margin: '0 auto',
      padding: '0 24px',
      ...style
    }
  }, children);
}

/* ---------- Bandeau preuve sociale ---------- */
function SocialProofStrip() {
  const {
    Rating,
    IconShield,
    IconTruck,
    IconReturn
  } = NSps();
  const items = [{
    node: /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8
      }
    }, Rating ? /*#__PURE__*/React.createElement(Rating, {
      value: 5,
      size: 15
    }) : null, /*#__PURE__*/React.createElement("strong", null, "4,9 / 5"), " d'apr\xE8s nos clients")
  }, {
    icon: IconShield,
    t: 'Satisfait ou remboursé'
  }, {
    icon: IconTruck,
    t: 'Livraison suivie 7–10 jours'
  }, {
    icon: IconReturn,
    t: 'Retours sans prise de tête'
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Produit \u2014 Preuve sociale",
    style: {
      background: 'var(--teal-darker)',
      color: '#fff',
      marginTop: 54
    }
  }, /*#__PURE__*/React.createElement(PdpContainer, {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '12px 38px',
      padding: '16px 24px'
    }
  }, items.map((it, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      fontSize: 13.5,
      fontWeight: 500,
      color: 'rgba(255,255,255,0.92)'
    }
  }, it.icon ? /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      color: '#FFD9C2'
    }
  }, /*#__PURE__*/React.createElement(it.icon, {
    size: 16
  })) : null, it.node || it.t))));
}

/* ---------- Comment ça marche ---------- */
function PdpHowItWorks() {
  const {
    Eyebrow
  } = NSps();
  const steps = [{
    n: '1',
    t: 'Tu le poses au sol.',
    d: "Dans le salon, sur la terrasse, là où il aime déjà se mettre. Idéalement à l'ombre, dans un endroit aéré."
  }, {
    n: '2',
    t: "Il s'allonge dessus.",
    d: "Le coton respirant laisse circuler l'air et ne retient pas la chaleur de son corps. Bien plus agréable que le canapé."
  }, {
    n: '3',
    t: 'Tu le laves quand tu veux.',
    d: 'Direction la machine, et il repart pour un tour. Zéro entretien, zéro recharge.'
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Produit \u2014 Comment \xE7a marche"
  }, /*#__PURE__*/React.createElement(PdpContainer, {
    style: {
      padding: '66px 24px 60px',
      textAlign: 'center'
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    style: {
      marginBottom: 12
    }
  }, "Comment \xE7a marche") : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 32,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      color: 'var(--ink)',
      margin: '0 0 42px'
    }
  }, "Aussi simple que \xE7a."), /*#__PURE__*/React.createElement("div", {
    className: "pdp-steps",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 28
    }
  }, steps.map(s => /*#__PURE__*/React.createElement("div", {
    key: s.n,
    style: {
      textAlign: 'center',
      padding: '0 12px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 54,
      height: 54,
      borderRadius: '50%',
      background: 'var(--teal)',
      color: '#fff',
      fontSize: 21,
      fontWeight: 800,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 18px',
      boxShadow: 'var(--shadow-teal, 0 6px 18px rgba(8,145,178,0.3))'
    }
  }, s.n), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 18,
      fontWeight: 700,
      color: 'var(--ink)',
      margin: '0 0 8px'
    }
  }, s.t), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14.5,
      lineHeight: 1.58,
      color: 'var(--muted)',
      margin: 0
    }
  }, s.d))))));
}

/* ---------- Comparatif honnête ---------- */
function PdpCompare() {
  const {
    Eyebrow,
    IconCheck,
    IconX
  } = NSps();
  const rows = [{
    t: 'Reste frais sans recharge',
    ice: true,
    gel: false,
    note: 'Le gel se « décharge » en 15–30 min puis doit refroidir'
  }, {
    t: 'Sans risque si ton chien le mordille',
    ice: true,
    gel: false,
    note: 'Le gel peut fuir et être ingéré'
  }, {
    t: 'Lavable en machine',
    ice: true,
    gel: false,
    note: "Les tapis gel se nettoient à l'éponge uniquement"
  }, {
    t: 'Confortable pour dormir des heures',
    ice: true,
    gel: false,
    note: 'Surface gel froide et plastique'
  }, {
    t: 'Effet glacial immédiat',
    ice: false,
    gel: true,
    note: "IceDream mise sur la fraîcheur constante, pas le choc froid"
  }];
  const Yes = () => /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      width: 26,
      height: 26,
      borderRadius: '50%',
      background: 'var(--teal-light)',
      color: 'var(--teal-deep)',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, IconCheck ? /*#__PURE__*/React.createElement(IconCheck, {
    size: 15
  }) : '✓');
  const No = () => /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      width: 26,
      height: 26,
      borderRadius: '50%',
      background: '#FBE9E7',
      color: '#C2410C',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, IconX ? /*#__PURE__*/React.createElement(IconX, {
    size: 14
  }) : '✕');
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Produit \u2014 Comparatif",
    style: {
      background: 'var(--cream)'
    }
  }, /*#__PURE__*/React.createElement(PdpContainer, {
    style: {
      padding: '64px 24px',
      maxWidth: 880
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: 32
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    style: {
      marginBottom: 12
    }
  }, "En toute honn\xEAtet\xE9") : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 32,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      color: 'var(--ink)',
      margin: '0 0 10px'
    }
  }, "Coton respirant ou tapis gel ?"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15.5,
      color: 'var(--ink-soft)',
      margin: '0 auto',
      maxWidth: 540,
      lineHeight: 1.6
    }
  }, "On pr\xE9f\xE8re te le dire franchement : les deux existent, voil\xE0 ce qui les distingue vraiment.")), /*#__PURE__*/React.createElement("div", {
    style: {
      background: '#fff',
      border: '1px solid var(--line)',
      borderRadius: 'var(--radius-lg, 16px)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-compare-row",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 110px 110px',
      gap: 10,
      padding: '14px 22px',
      background: 'var(--teal-50)',
      borderBottom: '1px solid var(--line)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--muted)',
      textTransform: 'uppercase',
      letterSpacing: '1px'
    }
  }, "Crit\xE8re"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13.5,
      fontWeight: 800,
      color: 'var(--teal-deep)',
      textAlign: 'center'
    }
  }, "IceDream"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13.5,
      fontWeight: 700,
      color: 'var(--muted)',
      textAlign: 'center'
    }
  }, "Tapis gel")), rows.map((r, i) => /*#__PURE__*/React.createElement("div", {
    key: r.t,
    className: "pdp-compare-row",
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 110px 110px',
      gap: 10,
      padding: '14px 22px',
      borderBottom: i < rows.length - 1 ? '1px solid var(--line)' : 'none',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 14.5,
      fontWeight: 600,
      color: 'var(--ink)'
    }
  }, r.t), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12.5,
      color: 'var(--muted)',
      marginTop: 2
    }
  }, r.note)), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, r.ice ? /*#__PURE__*/React.createElement(Yes, null) : /*#__PURE__*/React.createElement(No, null)), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, r.gel ? /*#__PURE__*/React.createElement(Yes, null) : /*#__PURE__*/React.createElement(No, null)))))));
}

/* ---------- Avis ---------- */
function PdpReviews() {
  const {
    Eyebrow,
    Rating,
    Card
  } = NSps();
  const reviews = [{
    txt: 'Nala cherchait toujours le carrelage. Maintenant elle file direct sur son matelas, et moi je suis plus tranquille.',
    who: 'Laura & Nala',
    city: 'Lyon',
    size: 'Taille M'
  }, {
    txt: "Simple, efficace, et surtout il l'utilise vraiment. Rien à brancher, je l'avais oublié dans le salon tout l'été.",
    who: 'Thomas & Oslo',
    city: 'Nantes',
    size: 'Taille L'
  }, {
    txt: 'Il est plus posé après les balades. Et moi je culpabilise moins quand il fait chaud.',
    who: 'Inès & Rio',
    city: 'Bordeaux',
    size: 'Taille S'
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Produit \u2014 Avis",
    id: "pdp-avis",
    style: {
      scrollMarginTop: 90
    }
  }, /*#__PURE__*/React.createElement(PdpContainer, {
    style: {
      padding: '64px 24px',
      textAlign: 'center'
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    style: {
      marginBottom: 12
    }
  }, "Avis clients") : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 32,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      color: 'var(--ink)',
      margin: '0 0 8px'
    }
  }, "Ils ont test\xE9, leurs chiens ont valid\xE9."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10,
      marginBottom: 38
    }
  }, Rating ? /*#__PURE__*/React.createElement(Rating, {
    value: 5,
    size: 18
  }) : null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 14,
      color: 'var(--muted)'
    }
  }, "4,9 / 5 \xB7 des ma\xEEtres tranquilles partout en France")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-reviews",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 18
    }
  }, reviews.map(r => Card ? /*#__PURE__*/React.createElement(Card, {
    key: r.who,
    variant: "soft",
    padding: "lg",
    radius: "lg",
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 12
    }
  }, Rating ? /*#__PURE__*/React.createElement(Rating, {
    value: 5,
    size: 15
  }) : null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 11.5,
      fontWeight: 700,
      color: 'var(--teal-deep)',
      background: 'var(--teal-light)',
      borderRadius: 999,
      padding: '3px 10px'
    }
  }, "Achat v\xE9rifi\xE9 \xB7 ", r.size)), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.58,
      color: 'var(--ink)',
      margin: '0 0 14px'
    }
  }, "\xAB ", r.txt, " \xBB"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13.5,
      fontWeight: 700,
      color: 'var(--teal-deep)'
    }
  }, r.who, " ", /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 500,
      color: 'var(--muted)'
    }
  }, "\xB7 ", r.city))) : null))));
}

/* ---------- Garantie ---------- */
function PdpGuarantee() {
  const {
    IconShield
  } = NSps();
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Produit \u2014 Garantie",
    style: {
      background: 'var(--cream)'
    }
  }, /*#__PURE__*/React.createElement(PdpContainer, {
    style: {
      padding: '56px 24px',
      maxWidth: 820
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-guarantee",
    style: {
      display: 'flex',
      gap: 26,
      alignItems: 'center',
      background: '#fff',
      border: '1.5px solid var(--teal-light)',
      borderRadius: 'var(--radius-xl, 24px)',
      padding: '34px 38px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 72,
      height: 72,
      borderRadius: '50%',
      background: 'var(--teal-light)',
      color: 'var(--teal-deep)',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    }
  }, IconShield ? /*#__PURE__*/React.createElement(IconShield, {
    size: 34
  }) : null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 22,
      fontWeight: 800,
      letterSpacing: '-0.4px',
      color: 'var(--ink)',
      margin: '0 0 8px'
    }
  }, "S'il ne l'adopte pas, on te rembourse."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14.5,
      lineHeight: 1.62,
      color: 'var(--ink-soft)',
      margin: 0
    }
  }, "Laisse-lui quelques jours pour prendre ses marques. S'il n'en veut vraiment pas, tu nous \xE9cris et on te rembourse \u2014 pas de formulaire \xE0 rallonge, pas de question pi\xE8ge. C'est \xE7a, la garantie satisfait ou rembours\xE9 Canigloo.")))));
}

/* ---------- FAQ extraite ---------- */
function PdpFaq() {
  const {
    Eyebrow,
    IconChevronDown,
    Button
  } = NSps();
  const [open, setOpen] = React.useState(0);
  const qa = [{
    q: "C'est un tapis réfrigérant avec du gel ?",
    a: "Non — IceDream ne contient ni gel, ni eau. C'est du coton respirant, tissé pour ne pas retenir la chaleur. Pas de froid glacial, mais un coin frais qui le reste, sans recharge ni fuite."
  }, {
    q: 'Quelle taille choisir ?',
    a: "Celle où il peut s'allonger en entier : S 45×35 cm (Chihuahua, Yorkshire), M 55×45 cm (Beagle, Bouledogue français), L 76×58 cm (Labrador, Golden). Entre deux tailles ? Prends la plus grande."
  }, {
    q: "Mon chien va-t-il l'utiliser ?",
    a: "La plupart des chiens adoptent vite un coin frais et doux, surtout les jours de chaleur. Installe-le là où il aime déjà se poser. Et sinon : satisfait ou remboursé, zéro risque."
  }, {
    q: 'Quels sont les délais de livraison ?',
    a: 'Livraison suivie en 7 à 10 jours partout en France, avec numéro de suivi envoyé par email.'
  }];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Produit \u2014 FAQ"
  }, /*#__PURE__*/React.createElement(PdpContainer, {
    style: {
      padding: '64px 24px 70px',
      maxWidth: 780
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: 32
    }
  }, Eyebrow ? /*#__PURE__*/React.createElement(Eyebrow, {
    style: {
      marginBottom: 12
    }
  }, "Questions fr\xE9quentes") : null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 30,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      color: 'var(--ink)',
      margin: 0
    }
  }, "Avant de te d\xE9cider.")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12
    }
  }, qa.map((item, i) => {
    const isOpen = open === i;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      style: {
        background: '#fff',
        border: `1px solid ${isOpen ? 'var(--teal)' : 'var(--line)'}`,
        borderRadius: 'var(--radius-md, 12px)',
        overflow: 'hidden',
        transition: 'border-color .2s'
      }
    }, /*#__PURE__*/React.createElement("button", {
      onClick: () => setOpen(isOpen ? -1 : i),
      "aria-expanded": isOpen,
      style: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: '17px 22px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        fontFamily: 'inherit'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 15.5,
        fontWeight: 600,
        color: 'var(--ink)'
      }
    }, item.q), /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'var(--teal)',
        flexShrink: 0,
        transform: isOpen ? 'rotate(180deg)' : 'none',
        transition: 'transform .2s',
        display: 'inline-flex'
      }
    }, IconChevronDown ? /*#__PURE__*/React.createElement(IconChevronDown, {
      size: 19
    }) : '⌄')), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'grid',
        gridTemplateRows: isOpen ? '1fr' : '0fr',
        transition: 'grid-template-rows .25s'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        overflow: 'hidden'
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        padding: '0 22px 18px',
        fontSize: 14.5,
        lineHeight: 1.62,
        color: 'var(--ink-soft)'
      }
    }, item.a))));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginTop: 26
    }
  }, Button ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline",
    size: "md",
    onClick: () => {
      window.location.href = '/pages/faq';
    }
  }, "Voir toutes les questions") : null)));
}
window.CG_PDP_SECTIONS = {
  SocialProofStrip,
  PdpHowItWorks,
  PdpCompare,
  PdpReviews,
  PdpGuarantee,
  PdpFaq
};
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/produit/produit-sections.jsx", error: String((e && e.message) || e) }); }

// pages/produit/tweaks-panel.jsx
try { (() => {
// @ds-adherence-ignore -- omelette starter scaffold (raw elements/hex/px by design)

/* BEGIN USAGE */
// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
// Exports (to window): useTweaks, TweaksPanel, TweakSection, TweakRow, TweakSlider,
//   TweakToggle, TweakRadio, TweakSelect, TweakText, TweakNumber, TweakColor, TweakButton.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// TweakRadio is the segmented control for 2–3 short options (auto-falls-back to
// TweakSelect past ~16/~10 chars per label); reach for TweakSelect directly when
// options are many or long. For color tweaks always curate 3-4 options rather than
// a free picker; an option can also be a whole 2–5 color palette (the stored value
// is the array). The Tweak* controls are a floor, not a ceiling — build custom
// controls inside the panel if a tweak calls for UI they don't cover.
/* END USAGE */
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null ? keyOrEdits : {
      [keyOrEdits]: val
    };
    setValues(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: '__edit_mode_set_keys',
      edits
    }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', {
      detail: edits
    }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({
  title = 'Tweaks',
  children
}) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({
    x: 16,
    y: 16
  });
  const PAD = 16;
  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth,
      h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y))
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);
  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);
  React.useEffect(() => {
    const onMsg = e => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({
      type: '__edit_mode_available'
    }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({
      type: '__edit_mode_dismissed'
    }, '*');
  };
  const onDragStart = e => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX,
      sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = ev => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy)
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, __TWEAKS_STYLE), /*#__PURE__*/React.createElement("div", {
    ref: dragRef,
    className: "twk-panel",
    "data-omelette-chrome": "",
    style: {
      right: offsetRef.current.x,
      bottom: offsetRef.current.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-hd",
    onMouseDown: onDragStart
  }, /*#__PURE__*/React.createElement("b", null, title), /*#__PURE__*/React.createElement("button", {
    className: "twk-x",
    "aria-label": "Close tweaks",
    onMouseDown: e => e.stopPropagation(),
    onClick: dismiss
  }, "\u2715")), /*#__PURE__*/React.createElement("div", {
    className: "twk-body"
  }, children)));
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({
  label,
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "twk-sect"
  }, label), children);
}
function TweakRow({
  label,
  value,
  children,
  inline = false
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: inline ? 'twk-row twk-row-h' : 'twk-row'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label), value != null && /*#__PURE__*/React.createElement("span", {
    className: "twk-val"
  }, value)), children);
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({
  label,
  value,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label,
    value: `${value}${unit}`
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    className: "twk-slider",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: e => onChange(Number(e.target.value))
  }));
}
function TweakToggle({
  label,
  value,
  onChange
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-row twk-row-h"
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-lbl"
  }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "twk-toggle",
    "data-on": value ? '1' : '0',
    role: "switch",
    "aria-checked": !!value,
    onClick: () => onChange(!value)
  }, /*#__PURE__*/React.createElement("i", null)));
}
function TweakRadio({
  label,
  value,
  options,
  onChange
}) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = o => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({
    2: 16,
    3: 10
  }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = s => {
      const m = options.find(o => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return /*#__PURE__*/React.createElement(TweakSelect, {
      label: label,
      value: value,
      options: options,
      onChange: s => onChange(resolve(s))
    });
  }
  const opts = options.map(o => typeof o === 'object' ? o : {
    value: o,
    label: o
  });
  const idx = Math.max(0, opts.findIndex(o => o.value === value));
  const n = opts.length;
  const segAt = clientX => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor((clientX - r.left - 2) / inner * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };
  const onPointerDown = e => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = ev => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    ref: trackRef,
    role: "radiogroup",
    onPointerDown: onPointerDown,
    className: dragging ? 'twk-seg dragging' : 'twk-seg'
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-seg-thumb",
    style: {
      left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
      width: `calc((100% - 4px) / ${n})`
    }
  }), opts.map(o => /*#__PURE__*/React.createElement("button", {
    key: o.value,
    type: "button",
    role: "radio",
    "aria-checked": o.value === value
  }, o.label))));
}
function TweakSelect({
  label,
  value,
  options,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("select", {
    className: "twk-field",
    value: value,
    onChange: e => onChange(e.target.value)
  }, options.map(o => {
    const v = typeof o === 'object' ? o.value : o;
    const l = typeof o === 'object' ? o.label : o;
    return /*#__PURE__*/React.createElement("option", {
      key: v,
      value: v
    }, l);
  })));
}
function TweakText({
  label,
  value,
  placeholder,
  onChange
}) {
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("input", {
    className: "twk-field",
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: e => onChange(e.target.value)
  }));
}
function TweakNumber({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange
}) {
  const clamp = n => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({
    x: 0,
    val: 0
  });
  const onScrubStart = e => {
    e.preventDefault();
    startRef.current = {
      x: e.clientX,
      val: value
    };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = ev => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "twk-num"
  }, /*#__PURE__*/React.createElement("span", {
    className: "twk-num-lbl",
    onPointerDown: onScrubStart
  }, label), /*#__PURE__*/React.createElement("input", {
    type: "number",
    value: value,
    min: min,
    max: max,
    step: step,
    onChange: e => onChange(clamp(Number(e.target.value)))
  }), unit && /*#__PURE__*/React.createElement("span", {
    className: "twk-num-unit"
  }, unit));
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, c => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = n >> 16 & 255,
    g = n >> 8 & 255,
    b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}
const __TwkCheck = ({
  light
}) => /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 14 14",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7.2 5.8 10 11 4.2",
  fill: "none",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: light ? 'rgba(0,0,0,.78)' : '#fff'
}));

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({
  label,
  value,
  options,
  onChange
}) {
  if (!options || !options.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "twk-row twk-row-h"
    }, /*#__PURE__*/React.createElement("div", {
      className: "twk-lbl"
    }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("input", {
      type: "color",
      className: "twk-swatch",
      value: value,
      onChange: e => onChange(e.target.value)
    }));
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = o => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return /*#__PURE__*/React.createElement(TweakRow, {
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: "twk-chips",
    role: "radiogroup"
  }, options.map((o, i) => {
    const colors = Array.isArray(o) ? o : [o];
    const [hero, ...rest] = colors;
    const sup = rest.slice(0, 4);
    const on = key(o) === cur;
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      type: "button",
      className: "twk-chip",
      role: "radio",
      "aria-checked": on,
      "data-on": on ? '1' : '0',
      "aria-label": colors.join(', '),
      title: colors.join(' · '),
      style: {
        background: hero
      },
      onClick: () => onChange(o)
    }, sup.length > 0 && /*#__PURE__*/React.createElement("span", null, sup.map((c, j) => /*#__PURE__*/React.createElement("i", {
      key: j,
      style: {
        background: c
      }
    }))), on && /*#__PURE__*/React.createElement(__TwkCheck, {
      light: __twkIsLight(hero)
    }));
  })));
}
function TweakButton({
  label,
  onClick,
  secondary = false
}) {
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: secondary ? 'twk-btn secondary' : 'twk-btn',
    onClick: onClick
  }, label);
}
Object.assign(window, {
  useTweaks,
  TweaksPanel,
  TweakSection,
  TweakRow,
  TweakSlider,
  TweakToggle,
  TweakRadio,
  TweakSelect,
  TweakText,
  TweakNumber,
  TweakColor,
  TweakButton
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "pages/produit/tweaks-panel.jsx", error: String((e && e.message) || e) }); }

// ui_kits/shopify/Icons.jsx
try { (() => {
/* Canigloo functional line-icon set — clean 24px, 2px stroke, rounded joins,
   in the spirit of the brand's line-art illustrations. (For production, Lucide
   is the recommended drop-in match: same stroke weight & rounded caps.) */

function Svg({
  size = 24,
  color = 'currentColor',
  sw = 2,
  children,
  style
}) {
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: sw,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      display: 'block',
      ...style
    },
    "aria-hidden": "true"
  }, children);
}
function IconWind(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M3 8h11a3 3 0 1 0-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h15a3 3 0 1 1-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16h8a2.5 2.5 0 1 1-2.5 2.5"
  }));
}
function IconPlugOff(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M9 9v3a3 3 0 0 0 3 3h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9V5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 3 18 18"
  }));
}
function IconWash(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("rect", {
    x: "4",
    y: "3",
    width: "16",
    height: "18",
    rx: "2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "13",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7h.01M11.5 7h.01"
  }));
}
function IconTruck(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M3 6h11v9H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9h4l3 3v3h-7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "18",
    r: "1.6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "18",
    r: "1.6"
  }));
}
function IconShield(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 12 2 2 4-4"
  }));
}
function IconLock(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "11",
    width: "14",
    height: "9",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11V8a4 4 0 0 1 8 0v3"
  }));
}
function IconReturn(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M3 8h12a5 5 0 0 1 0 10H8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 5-3 3 3 3"
  }));
}
function IconBed(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M3 17v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13V7M21 17v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11V9a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2"
  }));
}
function IconSmile(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14s1.5 2 4 2 4-2 4-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h.01M15 9h.01"
  }));
}
function IconSun(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
  }));
}
function IconPaw(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("ellipse", {
    cx: "7",
    cy: "9",
    rx: "1.6",
    ry: "2.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "12",
    cy: "7.5",
    rx: "1.6",
    ry: "2.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "17",
    cy: "9",
    rx: "1.6",
    ry: "2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12c-2.5 0-4.5 2-4.5 4 0 1.6 1.4 2.5 4.5 2.5s4.5-.9 4.5-2.5c0-2-2-4-4.5-4Z"
  }));
}
function IconChevronDown(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "m6 9 6 6 6-6"
  }));
}
function IconCart(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "20",
    r: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 3h3l2.4 12.2a1.5 1.5 0 0 0 1.5 1.3h8.1a1.5 1.5 0 0 0 1.5-1.2L21 7H6"
  }));
}
function IconArrowRight(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14M13 6l6 6-6 6"
  }));
}
function IconPlus(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M12 5v14M5 12h14"
  }));
}
function IconMinus(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14"
  }));
}
function IconClose(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M6 6l12 12M18 6 6 18"
  }));
}
function IconMenu(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18M3 12h18M3 18h18"
  }));
}
function IconCheck(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "m5 12 5 5L20 7"
  }));
}
function IconHeart(p) {
  return /*#__PURE__*/React.createElement(Svg, p, /*#__PURE__*/React.createElement("path", {
    d: "M12 20s-7-4.5-9.5-9A4.5 4.5 0 0 1 12 6a4.5 4.5 0 0 1 9.5 5c-2.5 4.5-9.5 9-9.5 9Z"
  }));
}
Object.assign(__ds_scope, { IconWind, IconPlugOff, IconWash, IconTruck, IconShield, IconLock, IconReturn, IconBed, IconSmile, IconSun, IconPaw, IconChevronDown, IconCart, IconArrowRight, IconPlus, IconMinus, IconClose, IconMenu, IconCheck, IconHeart });
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/shopify/Icons.jsx", error: String((e && e.message) || e) }); }

// ui_kits/shopify/app.js
try { (() => {
/* Canigloo Shopify storefront — app shell, cart drawer, composition. */
const NSa = () => window.CaniglooDesignSystem_665af4 || {};
function CartDrawer({
  open,
  items,
  onClose,
  onQty,
  onRemove
}) {
  const {
    Button: BtnA,
    IconClose,
    IconCart: IconCartA,
    IconPlus: IconPlusA,
    IconMinus: IconMinusA,
    IconCheck: IconCheckA
  } = NSa();
  const total = items.reduce((s, it) => s + it.price * it.qty, 0);
  const count = items.reduce((s, it) => s + it.qty, 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    style: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(15,46,58,0.4)',
      backdropFilter: 'blur(2px)',
      opacity: open ? 1 : 0,
      pointerEvents: open ? 'auto' : 'none',
      transition: 'opacity .25s',
      zIndex: 50
    }
  }), /*#__PURE__*/React.createElement("aside", {
    style: {
      position: 'fixed',
      top: 0,
      right: 0,
      height: '100%',
      width: 400,
      maxWidth: '92vw',
      background: '#fff',
      boxShadow: 'var(--shadow-lg)',
      transform: open ? 'translateX(0)' : 'translateX(105%)',
      transition: 'transform .3s var(--ease-out)',
      zIndex: 51,
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '20px 22px',
      borderBottom: '1px solid var(--line)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 18,
      fontWeight: 700,
      color: 'var(--ink)'
    }
  }, "Ton panier ", count > 0 && /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, "(", count, ")")), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    "aria-label": "Fermer",
    style: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--muted)',
      display: 'inline-flex',
      padding: 4
    }
  }, /*#__PURE__*/React.createElement(IconClose, {
    size: 22
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      overflowY: 'auto',
      padding: '8px 22px'
    }
  }, items.length === 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      padding: '64px 16px',
      color: 'var(--muted)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex',
      color: 'var(--line)',
      marginBottom: 14
    }
  }, /*#__PURE__*/React.createElement(IconCartA, {
    size: 56
  })), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15,
      margin: 0
    }
  }, "Ton panier est vide pour l\u2019instant.")) : items.map(it => /*#__PURE__*/React.createElement("div", {
    key: it.size + it.color,
    style: {
      display: 'flex',
      gap: 14,
      padding: '16px 0',
      borderBottom: '1px solid var(--line)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 72,
      height: 72,
      borderRadius: 'var(--radius-sm)',
      overflow: 'hidden',
      background: 'var(--cream)',
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: it.img,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 14.5,
      fontWeight: 700,
      color: 'var(--ink)'
    }
  }, "IceDream"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12.5,
      color: 'var(--muted)',
      marginBottom: 8
    }
  }, "Taille ", it.size, " \xB7 ", it.colorLabel, " \xB7 ", it.dim), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid var(--line)',
      borderRadius: 'var(--radius-xs)'
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => onQty(it, -1),
    style: {
      padding: '4px 8px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink)',
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(IconMinusA, {
    size: 13
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 22,
      textAlign: 'center',
      fontSize: 13,
      fontWeight: 700
    }
  }, it.qty), /*#__PURE__*/React.createElement("button", {
    onClick: () => onQty(it, 1),
    style: {
      padding: '4px 8px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink)',
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(IconPlusA, {
    size: 13
  }))), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 14,
      fontWeight: 700,
      color: 'var(--ink)'
    }
  }, (it.price * it.qty).toFixed(2).replace('.', ','), " \u20AC")), /*#__PURE__*/React.createElement("button", {
    onClick: () => onRemove(it),
    style: {
      fontSize: 11.5,
      color: 'var(--muted)',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '6px 0 0',
      textDecoration: 'underline'
    }
  }, "Retirer"))))), items.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: '1px solid var(--line)',
      padding: '18px 22px 22px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 14
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 15,
      color: 'var(--ink-soft)'
    }
  }, "Sous-total"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 19,
      fontWeight: 800,
      color: 'var(--ink)'
    }
  }, total.toFixed(2).replace('.', ','), " \u20AC")), /*#__PURE__*/React.createElement(BtnA, {
    variant: "primary",
    size: "lg",
    block: true
  }, "Passer la commande"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      marginTop: 12,
      fontSize: 12,
      color: 'var(--muted)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--success)',
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(IconCheckA, {
    size: 14
  })), "Livraison suivie 7 \xE0 10 jours \xB7 Satisfait ou rembours\xE9"))));
}
function Toast({
  show,
  label
}) {
  const {
    IconCheck: IconCheckA
  } = NSa();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'fixed',
      bottom: 24,
      left: '50%',
      transform: `translateX(-50%) translateY(${show ? 0 : 20}px)`,
      opacity: show ? 1 : 0,
      pointerEvents: 'none',
      transition: 'all .3s var(--ease-out)',
      zIndex: 60,
      background: 'var(--ink)',
      color: '#fff',
      padding: '13px 20px',
      borderRadius: 'var(--radius-pill)',
      fontSize: 14,
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      gap: 9,
      boxShadow: 'var(--shadow-lg)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#7FE3B8',
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(IconCheckA, {
    size: 18
  })), label);
}
function App() {
  const {
    useState,
    useRef
  } = React;
  const [items, setItems] = useState([]);
  const [drawer, setDrawer] = useState(false);
  const [toast, setToast] = useState(false);
  const toastTimer = useRef(null);
  const flashToast = () => {
    setToast(true);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(false), 1900);
  };
  const addItem = item => {
    setItems(prev => {
      const idx = prev.findIndex(p => p.size === item.size && p.color === item.color);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = {
          ...next[idx],
          qty: next[idx].qty + item.qty
        };
        return next;
      }
      return [...prev, item];
    });
    flashToast();
    setTimeout(() => setDrawer(true), 350);
  };
  const changeQty = (item, delta) => {
    setItems(prev => prev.map(p => p.size === item.size && p.color === item.color ? {
      ...p,
      qty: p.qty + delta
    } : p).filter(p => p.qty > 0));
  };
  const removeItem = item => setItems(prev => prev.filter(p => !(p.size === item.size && p.color === item.color)));
  const count = items.reduce((s, it) => s + it.qty, 0);
  const scrollTo = id => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - 70,
      behavior: 'smooth'
    });
  };
  const scrollToProduct = () => scrollTo('product');
  const scrollToHow = () => scrollTo('how');
  return /*#__PURE__*/React.createElement("div", {
    id: "top"
  }, /*#__PURE__*/React.createElement(AnnouncementBar, null), /*#__PURE__*/React.createElement(SiteHeader, {
    cartCount: count,
    onCart: () => setDrawer(true)
  }), /*#__PURE__*/React.createElement(Hero, {
    onShop: scrollToProduct,
    onHow: scrollToHow
  }), /*#__PURE__*/React.createElement(TrustStrip, null), /*#__PURE__*/React.createElement(EmotionBlock, {
    onShop: scrollToProduct
  }), /*#__PURE__*/React.createElement(HowItWorks, null), /*#__PURE__*/React.createElement(Benefits, null), /*#__PURE__*/React.createElement(ProductBlock, {
    onAdd: addItem
  }), /*#__PURE__*/React.createElement(WhyCanigloo, null), /*#__PURE__*/React.createElement(Reviews, null), /*#__PURE__*/React.createElement(FAQ, null), /*#__PURE__*/React.createElement(FinalCTA, {
    onShop: scrollToProduct
  }), /*#__PURE__*/React.createElement(SiteFooter, null), /*#__PURE__*/React.createElement(CartDrawer, {
    open: drawer,
    items: items,
    onClose: () => setDrawer(false),
    onQty: changeQty,
    onRemove: removeItem
  }), /*#__PURE__*/React.createElement(Toast, {
    show: toast,
    label: "Ajout\xE9 au panier"
  }));
}

/* Auto-mount ONLY on the storefront page. The DS compiler bundles every .js/.jsx
   in the project, so this module's code executes on ANY page that loads
   _ds_bundle.js — the flag (set by ui_kits/shopify/index.html alone) prevents
   the storefront from hijacking component cards or other consumers. */
function mount() {
  if (!window.__CG_STOREFRONT__) return;
  if (window.__cgMounted) return;
  const ns = window.CaniglooDesignSystem_665af4;
  if (!ns || !ns.Button || typeof ReactDOM === 'undefined') {
    setTimeout(mount, 120);
    return;
  }
  if (!window.AnnouncementBar || !window.ProductBlock || !window.SiteFooter) {
    setTimeout(mount, 120);
    return;
  }
  const rootEl = document.getElementById('root');
  if (!rootEl) {
    setTimeout(mount, 120);
    return;
  }
  window.__cgMounted = true;
  ReactDOM.createRoot(rootEl).render(/*#__PURE__*/React.createElement(App, null));
}
mount();
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/shopify/app.js", error: String((e && e.message) || e) }); }

// ui_kits/shopify/sectionsBottom.js
try { (() => {
/* Canigloo Shopify storefront — bottom sections (why, reviews, FAQ, CTA, footer). */
const NSb = () => window.CaniglooDesignSystem_665af4 || {};

/* ---------- Why Canigloo ---------- */
function WhyCanigloo() {
  const {
    Eyebrow: EyebrowB
  } = NSb();
  const points = [{
    t: 'On connaît la culpabilité',
    d: 'Le voir haleter et se demander « est-ce que j’en fais assez ? ». C’est ce poids-là qu’on veut t’enlever.'
  }, {
    t: 'De la tranquillité, pas un gadget',
    d: 'IceDream, c’est la certitude d’avoir fait quelque chose pour lui. Tu peux souffler.'
  }, {
    t: 'Simple et honnête',
    d: 'Du coton respirant, lavable, livré vite. Pas de promesse de science-fiction, juste un coin frais.'
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--teal-darker)',
      color: '#fff'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      padding: '78px 32px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 640,
      marginBottom: 44
    }
  }, /*#__PURE__*/React.createElement(EyebrowB, {
    tone: "light",
    style: {
      marginBottom: 14
    }
  }, "Pourquoi Canigloo"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 36,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      margin: '0 0 16px',
      lineHeight: 1.1
    }
  }, "On ne parle pas qu\u2019\xE0 ton chien. ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#FFD9C2'
    }
  }, "On te parle \xE0 toi.")), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 17,
      lineHeight: 1.6,
      color: 'rgba(255,255,255,0.85)',
      margin: 0
    }
  }, "Les autres te vendent des degr\xE9s, du tissu, de la technologie. Nous, on a compris ce que tu ressens vraiment quand il a chaud.")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 20
    }
  }, points.map(p => /*#__PURE__*/React.createElement("div", {
    key: p.t,
    style: {
      background: 'rgba(255,255,255,0.07)',
      border: '1px solid rgba(255,255,255,0.14)',
      borderRadius: 'var(--radius-lg)',
      padding: '24px 22px'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 17,
      fontWeight: 700,
      margin: '0 0 8px'
    }
  }, p.t), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14,
      lineHeight: 1.55,
      color: 'rgba(255,255,255,0.82)',
      margin: 0
    }
  }, p.d))))));
}

/* ---------- Reviews ---------- */
function Reviews() {
  const {
    Eyebrow: EyebrowB,
    Rating: RatingB,
    Card: CardB
  } = NSb();
  const reviews = [{
    txt: 'Nala cherchait toujours le carrelage. Maintenant elle file direct sur son matelas, et moi je suis plus tranquille.',
    who: 'Laura & Nala',
    city: 'Lyon'
  }, {
    txt: 'Simple, efficace, et surtout il l’utilise vraiment. Rien à brancher, je l’avais oublié dans le salon tout l’été.',
    who: 'Thomas & Oslo',
    city: 'Nantes'
  }, {
    txt: 'Il est plus posé après les balades. Et moi je culpabilise moins quand il fait chaud.',
    who: 'Inès & Rio',
    city: 'Bordeaux'
  }];
  return /*#__PURE__*/React.createElement("section", {
    id: "avis",
    style: {
      background: '#fff'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      padding: '78px 32px',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(EyebrowB, {
    style: {
      marginBottom: 12
    }
  }, "Avis clients"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 34,
      fontWeight: 800,
      letterSpacing: '-0.5px',
      color: 'var(--ink)',
      margin: '0 0 8px'
    }
  }, "Ils ont test\xE9, leurs chiens ont valid\xE9."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10,
      marginBottom: 44
    }
  }, /*#__PURE__*/React.createElement(RatingB, {
    value: 5,
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 14,
      color: 'var(--muted)'
    }
  }, "4,9 / 5 \xB7 des ma\xEEtres tranquilles partout en France")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 20
    }
  }, reviews.map(r => /*#__PURE__*/React.createElement(CardB, {
    key: r.who,
    variant: "soft",
    padding: "lg",
    radius: "lg",
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(RatingB, {
    value: 5,
    size: 15,
    style: {
      marginBottom: 12
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.55,
      color: '#1c3a45',
      margin: '0 0 16px'
    }
  }, "\xAB ", r.txt, " \xBB"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13.5,
      fontWeight: 700,
      color: 'var(--teal-deep)'
    }
  }, r.who, " ", /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 500,
      color: 'var(--muted)'
    }
  }, "\xB7 ", r.city)))))));
}

/* ---------- FAQ ---------- */
function FAQ() {
  const {
    Eyebrow: EyebrowB,
    IconChevronDown
  } = NSb();
  const {
    useState
  } = React;
  const [open, setOpen] = useState(0);
  const qa = [{
    q: 'Comment fonctionne IceDream ?',
    a: 'C’est un matelas en coton respirant. Le tissu laisse circuler l’air et n’emmagasine pas la chaleur comme un coussin ou un canapé. Pas d’eau, pas d’électricité.'
  }, {
    q: 'Est-ce qu’il reste frais longtemps ?',
    a: 'Le coton reste respirant en permanence : il ne retient pas la chaleur du corps comme un textile épais. Pour un effet maximal, pose-le dans un endroit aéré, à l’ombre.'
  }, {
    q: 'Mon chien va-t-il l’utiliser ?',
    a: 'La plupart des chiens adoptent vite un coin frais et doux à eux, surtout les jours de chaleur. Et tu es couvert par la garantie satisfait ou remboursé.'
  }, {
    q: 'Quelle taille choisir ?',
    a: 'Celle où il peut s’allonger en entier, confortablement. S 45×35 cm, M 55×45 cm, L 76×58 cm.'
  }, {
    q: 'Comment le nettoyer ?',
    a: 'En machine. Tu le laves, tu le sèches, il repart pour un tour.'
  }, {
    q: 'Quels sont les délais de livraison ?',
    a: 'Livraison suivie en 7 à 10 jours, partout en France.'
  }];
  return /*#__PURE__*/React.createElement("section", {
    id: "faq",
    style: {
      background: 'var(--cream)'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      padding: '78px 32px',
      maxWidth: 820
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: 40
    }
  }, /*#__PURE__*/React.createElement(EyebrowB, {
    style: {
      marginBottom: 12
    }
  }, "FAQ"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 34,
      fontWeight: 800,
      letterSpacing: '-0.5px',
      color: 'var(--ink)',
      margin: 0
    }
  }, "Les questions qu\u2019on nous pose.")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12
    }
  }, qa.map((item, i) => {
    const isOpen = open === i;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      style: {
        background: '#fff',
        border: '1px solid var(--line)',
        borderRadius: 'var(--radius-md)',
        overflow: 'hidden'
      }
    }, /*#__PURE__*/React.createElement("button", {
      onClick: () => setOpen(isOpen ? -1 : i),
      style: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: '18px 22px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 16,
        fontWeight: 600,
        color: 'var(--ink)'
      }
    }, item.q), /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'var(--teal)',
        flexShrink: 0,
        transform: isOpen ? 'rotate(180deg)' : 'none',
        transition: 'transform .2s',
        display: 'inline-flex'
      }
    }, /*#__PURE__*/React.createElement(IconChevronDown, {
      size: 20
    }))), isOpen && /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '0 22px 20px',
        fontSize: 14.5,
        lineHeight: 1.6,
        color: 'var(--ink-soft)'
      }
    }, item.a));
  }))));
}

/* ---------- Final CTA ---------- */
function FinalCTA({
  onShop
}) {
  const {
    Button: BtnB,
    IconPaw: IconPawB,
    IconArrowRight: IconArrowRightB
  } = NSb();
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: '#fff'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      padding: '20px 32px 84px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'linear-gradient(135deg, var(--teal) 0%, var(--teal-deep) 100%)',
      borderRadius: 'var(--radius-xl)',
      padding: '60px 48px',
      textAlign: 'center',
      color: '#fff',
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: -30,
      right: -10,
      opacity: 0.14,
      color: '#fff'
    }
  }, /*#__PURE__*/React.createElement(IconPawB, {
    size: 150
  })), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 38,
      fontWeight: 800,
      letterSpacing: '-0.7px',
      margin: '0 0 14px',
      lineHeight: 1.08,
      position: 'relative'
    }
  }, "Et si, cet \xE9t\xE9, tu n\u2019avais plus \xE0 t\u2019inqui\xE9ter pour lui ?"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 17,
      color: 'rgba(255,255,255,0.9)',
      margin: '0 0 30px',
      position: 'relative'
    }
  }, "IceDream est pr\xEAt. Choisis sa taille, on s\u2019occupe du reste."), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      display: 'inline-block'
    }
  }, /*#__PURE__*/React.createElement(BtnB, {
    variant: "primary",
    size: "lg",
    onClick: onShop,
    iconRight: /*#__PURE__*/React.createElement(IconArrowRightB, {
      size: 18
    })
  }, "Offrir un coin frais \xE0 mon chien")), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 13,
      color: 'rgba(255,255,255,0.8)',
      marginTop: 18,
      position: 'relative'
    }
  }, "Livraison suivie 7 \xE0 10 jours \xB7 Satisfait ou rembours\xE9"))));
}

/* ---------- Footer ---------- */
function SiteFooter() {
  const cols = [{
    h: 'Boutique',
    items: ['IceDream', 'Comment ça marche', 'FAQ', 'Avis', 'À propos']
  }, {
    h: 'Aide',
    items: ['Contact', 'Livraison', 'Retours & remboursements', 'Suivi de commande']
  }, {
    h: 'Légal',
    items: ['Mentions légales', 'CGV', 'Confidentialité', 'Remboursement']
  }];
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      background: 'var(--ink)',
      color: 'rgba(255,255,255,0.75)'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      padding: '56px 32px 32px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1.4fr 1fr 1fr 1fr',
      gap: 32
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      marginBottom: 12
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('canigloo-favicon.png'),
    alt: "",
    style: {
      width: 38,
      height: 38,
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 21,
      fontWeight: 700,
      letterSpacing: '-0.4px',
      color: '#fff'
    }
  }, "Canigloo")), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14,
      color: 'rgba(255,255,255,0.6)',
      margin: 0,
      maxWidth: 240
    }
  }, "Ton chien m\xE9rite un \xE9t\xE9 parfait. Marque fran\xE7aise.")), cols.map(c => /*#__PURE__*/React.createElement("div", {
    key: c.h
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '1.5px',
      color: '#fff',
      marginBottom: 14
    }
  }, c.h), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 9
    }
  }, c.items.map(it => /*#__PURE__*/React.createElement("a", {
    key: it,
    href: "#",
    style: {
      fontSize: 13.5,
      color: 'rgba(255,255,255,0.7)',
      textDecoration: 'none'
    }
  }, it)))))), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: '1px solid rgba(255,255,255,0.12)',
      marginTop: 36,
      paddingTop: 20,
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 12,
      fontSize: 12.5,
      color: 'rgba(255,255,255,0.55)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "\xA9 2026 Canigloo \xB7 Paris \uD83C\uDDEB\uD83C\uDDF7"), /*#__PURE__*/React.createElement("span", null, "TikTok \xB7 Instagram \xB7 Facebook \u2192 @canigloo"))));
}
Object.assign(window, {
  WhyCanigloo,
  Reviews,
  FAQ,
  FinalCTA,
  SiteFooter
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/shopify/sectionsBottom.js", error: String((e && e.message) || e) }); }

// ui_kits/shopify/sectionsMid.js
try { (() => {
/* Canigloo Shopify storefront — middle sections (how it works, benefits, product). */
const NSm = () => window.CaniglooDesignSystem_665af4 || {};

/* ---------- How it works ---------- */
function HowItWorks() {
  const {
    Eyebrow: EyebrowM
  } = NSm();
  const steps = [{
    n: '1',
    t: 'Tu le poses au sol.',
    d: 'Dans le salon, sur la terrasse, là où il aime se mettre.'
  }, {
    n: '2',
    t: 'Il s’allonge dessus.',
    d: 'Le coton respirant reste frais et aéré, bien plus agréable que le canapé.'
  }, {
    n: '3',
    t: 'Tu le laves quand tu veux.',
    d: 'Direction la machine, et il repart pour un tour. Zéro entretien.'
  }];
  return /*#__PURE__*/React.createElement("section", {
    id: "how",
    style: {
      background: '#fff'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      padding: '78px 32px',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(EyebrowM, {
    style: {
      marginBottom: 12
    }
  }, "Comment \xE7a marche"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 36,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      color: 'var(--ink)',
      margin: '0 0 48px'
    }
  }, "Aussi simple que \xE7a."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 28
    }
  }, steps.map(s => /*#__PURE__*/React.createElement("div", {
    key: s.n,
    style: {
      textAlign: 'center',
      padding: '0 12px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 56,
      height: 56,
      borderRadius: '50%',
      background: 'var(--teal)',
      color: '#fff',
      fontSize: 22,
      fontWeight: 800,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 20px',
      boxShadow: 'var(--shadow-teal)'
    }
  }, s.n), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 19,
      fontWeight: 700,
      color: 'var(--ink)',
      margin: '0 0 8px'
    }
  }, s.t), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14.5,
      lineHeight: 1.55,
      color: 'var(--muted)',
      margin: 0
    }
  }, s.d)))), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 18,
      fontWeight: 600,
      color: 'var(--teal-deep)',
      marginTop: 44
    }
  }, "Pendant qu\u2019il profite de son coin frais, toi, tu souffles.")));
}

/* ---------- Benefits ---------- */
function Benefits() {
  const {
    Card: CardM,
    IconBed,
    IconSmile,
    IconSun
  } = NSm();
  const items = [{
    icon: /*#__PURE__*/React.createElement(IconBed, {
      size: 26
    }),
    t: 'Il a enfin son coin à lui',
    d: 'Un endroit frais et respirant, au lieu de tourner en rond pour trouver le carrelage.'
  }, {
    icon: /*#__PURE__*/React.createElement(IconSmile, {
      size: 26
    }),
    t: 'Toi, tu arrêtes de culpabiliser',
    d: 'Tu sais que tu as prévu quelque chose pour lui. Tu peux profiter de l’été, toi aussi.'
  }, {
    icon: /*#__PURE__*/React.createElement(IconSun, {
      size: 26
    }),
    t: 'L’été redevient un bon moment',
    d: 'À la maison, sur la terrasse, ou juste après la balade. Pour lui comme pour toi.'
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--cream)'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      padding: '72px 32px',
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 20
    }
  }, items.map(it => /*#__PURE__*/React.createElement(CardM, {
    key: it.t,
    variant: "default",
    padding: "lg",
    radius: "lg"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 50,
      height: 50,
      borderRadius: 'var(--radius-md)',
      background: 'var(--teal-light)',
      color: 'var(--teal-deep)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 18
    }
  }, it.icon), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 18,
      fontWeight: 700,
      color: 'var(--ink)',
      margin: '0 0 8px'
    }
  }, it.t), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14.5,
      lineHeight: 1.55,
      color: 'var(--muted)',
      margin: 0
    }
  }, it.d)))));
}

/* ---------- Product block (interactive) ---------- */
const SIZES = [{
  id: 'S',
  label: 'S',
  dim: '45 × 35 cm',
  price: 29.99
}, {
  id: 'M',
  label: 'M',
  dim: '55 × 45 cm',
  price: 39.99
}, {
  id: 'L',
  label: 'L',
  dim: '76 × 58 cm',
  price: 54.99
}];
const COLORS = [{
  id: 'bleu',
  label: 'Bleu',
  hex: '#7FD4E8',
  img: window.CG_ASSET('product-icedream.png')
}, {
  id: 'rose',
  label: 'Rose',
  hex: '#F4B8D0',
  img: window.CG_ASSET('product-2.png')
}];
function ProductBlock({
  onAdd
}) {
  const {
    Button: BtnM,
    Badge: BadgeM,
    Eyebrow: EyebrowM,
    Rating: RatingM,
    IconCheck,
    IconLock,
    IconTruck,
    IconPlus,
    IconMinus
  } = NSm();
  const {
    useState
  } = React;
  const [size, setSize] = useState('M');
  const [color, setColor] = useState('bleu');
  const [qty, setQty] = useState(1);
  const sizeObj = SIZES.find(s => s.id === size);
  const colorObj = COLORS.find(c => c.id === color);
  return /*#__PURE__*/React.createElement("section", {
    id: "product",
    style: {
      background: '#fff'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      padding: '78px 32px',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 56,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderRadius: 'var(--radius-xl)',
      overflow: 'hidden',
      background: 'var(--cream)',
      aspectRatio: '1 / 1',
      boxShadow: 'var(--shadow-md)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: colorObj.img,
    alt: "IceDream",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 16,
      left: 16,
      display: 'flex',
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(BadgeM, {
    tone: "accent"
  }, "Best-seller"), /*#__PURE__*/React.createElement(BadgeM, {
    tone: "solid"
  }, "Marque fran\xE7aise"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EyebrowM, {
    style: {
      marginBottom: 12
    }
  }, "Le h\xE9ros Canigloo"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 34,
      fontWeight: 800,
      letterSpacing: '-0.5px',
      color: 'var(--ink)',
      margin: '0 0 10px'
    }
  }, "IceDream, le coin frais que tu lui offres."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      marginBottom: 18
    }
  }, /*#__PURE__*/React.createElement(RatingM, {
    value: 5,
    size: 17
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13,
      color: 'var(--muted)'
    }
  }, "Pens\xE9 pour les chiens qui m\xE9ritent mieux qu\u2019un bout de carrelage.")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'baseline',
      gap: 10,
      marginBottom: 22
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 34,
      fontWeight: 800,
      color: 'var(--ink)'
    }
  }, sizeObj.price.toFixed(2).replace('.', ','), " \u20AC"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 15,
      color: 'var(--muted)',
      textDecoration: 'line-through'
    }
  }, (sizeObj.price * 1.4).toFixed(2).replace('.', ','), " \u20AC"), /*#__PURE__*/React.createElement(BadgeM, {
    tone: "orange",
    size: "sm"
  }, "-30 %")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12.5,
      fontWeight: 600,
      color: 'var(--ink)',
      marginBottom: 8
    }
  }, "Taille \u2014 ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, sizeObj.dim)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 10
    }
  }, SIZES.map(s => {
    const active = s.id === size;
    return /*#__PURE__*/React.createElement("button", {
      key: s.id,
      onClick: () => setSize(s.id),
      style: {
        flex: 1,
        padding: '12px 8px',
        borderRadius: 'var(--radius-sm)',
        cursor: 'pointer',
        border: active ? '1.5px solid var(--teal)' : '1.5px solid var(--line)',
        background: active ? 'var(--teal-50)' : '#fff',
        textAlign: 'center',
        transition: 'all .15s'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 15,
        fontWeight: 700,
        color: active ? 'var(--teal-deep)' : 'var(--ink)'
      }
    }, s.label), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 11,
        color: 'var(--muted)',
        marginTop: 2
      }
    }, s.dim));
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12.5,
      fontWeight: 600,
      color: 'var(--ink)',
      marginBottom: 8
    }
  }, "Coloris \u2014 ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, colorObj.label)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 10
    }
  }, COLORS.map(c => {
    const active = c.id === color;
    return /*#__PURE__*/React.createElement("button", {
      key: c.id,
      onClick: () => setColor(c.id),
      "aria-label": c.label,
      style: {
        width: 38,
        height: 38,
        borderRadius: '50%',
        cursor: 'pointer',
        background: c.hex,
        border: active ? '2px solid var(--teal)' : '2px solid var(--line)',
        outline: active ? '2px solid #fff' : 'none',
        outlineOffset: -4,
        boxShadow: active ? '0 0 0 2px var(--teal)' : 'none',
        transition: 'all .15s'
      }
    });
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 12,
      alignItems: 'stretch',
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      border: '1.5px solid var(--line)',
      borderRadius: 'var(--radius-sm)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => setQty(q => Math.max(1, q - 1)),
    style: {
      padding: '0 12px',
      height: '100%',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink)',
      display: 'flex',
      alignItems: 'center'
    },
    "aria-label": "Moins"
  }, /*#__PURE__*/React.createElement(IconMinus, {
    size: 16
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 34,
      textAlign: 'center',
      fontSize: 15,
      fontWeight: 700,
      color: 'var(--ink)'
    }
  }, qty), /*#__PURE__*/React.createElement("button", {
    onClick: () => setQty(q => q + 1),
    style: {
      padding: '0 12px',
      height: '100%',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink)',
      display: 'flex',
      alignItems: 'center'
    },
    "aria-label": "Plus"
  }, /*#__PURE__*/React.createElement(IconPlus, {
    size: 16
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(BtnM, {
    variant: "primary",
    size: "lg",
    block: true,
    onClick: () => onAdd({
      size,
      color,
      qty,
      price: sizeObj.price,
      dim: sizeObj.dim,
      colorLabel: colorObj.label,
      img: colorObj.img
    })
  }, "Ajouter au panier \xB7 ", (sizeObj.price * qty).toFixed(2).replace('.', ','), " \u20AC"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 18,
      flexWrap: 'wrap',
      fontSize: 12.5,
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--success)',
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(IconCheck, {
    size: 15
  })), "Satisfait ou rembours\xE9"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--teal)',
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(IconLock, {
    size: 15
  })), "Paiement s\xE9curis\xE9"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--teal)',
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(IconTruck, {
    size: 15
  })), "Livraison 7 \xE0 10 j")))));
}
Object.assign(window, {
  HowItWorks,
  Benefits,
  ProductBlock
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/shopify/sectionsMid.js", error: String((e && e.message) || e) }); }

// ui_kits/shopify/sectionsTop.js
try { (() => {
/* Canigloo Shopify storefront — top sections.
   Browser-babel file: reads the DS namespace lazily (inside each component) so the
   page tolerates a not-yet-compiled bundle, then renders once it's available. */
const MAXW = 1180;
const NS = () => window.CaniglooDesignSystem_665af4 || {};
function Container({
  children,
  style
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: MAXW,
      margin: '0 auto',
      padding: '0 32px',
      ...style
    }
  }, children);
}

/* ---------- Announcement bar ---------- */
function AnnouncementBar() {
  const {
    IconPaw
  } = NS();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--teal-darker)',
      color: '#fff',
      fontSize: 13,
      fontWeight: 500,
      textAlign: 'center',
      padding: '9px 16px',
      letterSpacing: '.2px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      color: '#FFD9C2'
    }
  }, /*#__PURE__*/React.createElement(IconPaw, {
    size: 15
  })), "Marque fran\xE7aise \xB7 Livraison suivie 7 \xE0 10 jours \xB7 Satisfait ou rembours\xE9");
}

/* ---------- Header (même header que la boutique) ---------- */
function PersonIconTop({
  size = 19
}) {
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  }));
}
function SiteHeader({
  cartCount,
  onCart
}) {
  const {
    Button,
    IconCart,
    IconArrowRight
  } = NS();
  const links = [{
    title: 'Accueil',
    url: '#top',
    active: true
  }, {
    title: 'IceDream',
    url: '/pages/produit'
  }, {
    title: 'FAQ',
    url: '/pages/faq'
  }, {
    title: 'Blog',
    url: '/pages/blog'
  }, {
    title: 'À propos',
    url: '/pages/a-propos'
  }, {
    title: 'Contact',
    url: '/pages/contact'
  }];
  return /*#__PURE__*/React.createElement("header", {
    style: {
      position: 'sticky',
      top: 0,
      zIndex: 30,
      background: '#fff',
      boxShadow: '0 .125rem .25rem rgba(15,46,58,0.075)',
      padding: '12px 0'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#top",
    style: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('canigloo-logo-principal.png'),
    alt: "Canigloo",
    style: {
      height: 46,
      width: 'auto',
      display: 'block'
    }
  })), /*#__PURE__*/React.createElement("nav", {
    className: "cg-nav",
    style: {
      display: 'flex',
      gap: 2,
      justifyContent: 'center',
      flex: 1
    }
  }, links.map(l => /*#__PURE__*/React.createElement("a", {
    key: l.title,
    href: l.url,
    style: {
      whiteSpace: 'nowrap',
      fontSize: 15,
      fontWeight: l.active ? 700 : 600,
      color: l.active ? 'var(--teal)' : 'var(--ink)',
      textDecoration: 'none',
      padding: '8px 12px',
      borderRadius: 8
    },
    onMouseEnter: e => e.currentTarget.style.color = 'var(--teal)',
    onMouseLeave: e => e.currentTarget.style.color = l.active ? 'var(--teal)' : 'var(--ink)'
  }, l.title))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      flexShrink: 0
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "cg-connexion",
    style: {
      whiteSpace: 'nowrap',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 7,
      fontSize: 14.5,
      fontWeight: 600,
      color: 'var(--ink)',
      textDecoration: 'none',
      padding: '8px 10px'
    }
  }, /*#__PURE__*/React.createElement(PersonIconTop, null), " Connexion"), /*#__PURE__*/React.createElement("div", {
    className: "cg-cta-header",
    style: {
      margin: '0 4px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "sm",
    iconRight: IconArrowRight ? /*#__PURE__*/React.createElement(IconArrowRight, {
      size: 16
    }) : null,
    onClick: onCart
  }, "Commander")), /*#__PURE__*/React.createElement("button", {
    onClick: onCart,
    "aria-label": "Panier",
    style: {
      position: 'relative',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: 'var(--ink)',
      display: 'inline-flex',
      padding: 8,
      marginRight: -8
    }
  }, /*#__PURE__*/React.createElement(IconCart, {
    size: 23
  }), cartCount > 0 && /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 0,
      right: 0,
      background: 'var(--orange)',
      color: '#fff',
      fontSize: 11,
      fontWeight: 700,
      width: 18,
      height: 18,
      borderRadius: 9,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, cartCount)))));
}

/* ---------- Hero ---------- */
function Hero({
  onShop,
  onHow
}) {
  const {
    Button,
    Eyebrow,
    Rating,
    IconArrowRight
  } = NS();
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'linear-gradient(180deg, var(--teal-50) 0%, #fff 100%)',
      position: 'relative',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      display: 'grid',
      gridTemplateColumns: '1.05fr 1fr',
      gap: 56,
      alignItems: 'center',
      padding: '64px 32px 72px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "cg-hero-copy"
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "orange",
    wide: true,
    style: {
      marginBottom: 18
    }
  }, "\uD83C\uDDEB\uD83C\uDDF7 La marque qui pense \xE0 ton chien, et \xE0 toi"), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: 60,
      lineHeight: 1.02,
      fontWeight: 800,
      letterSpacing: '-1.5px',
      color: 'var(--ink)',
      margin: '0 0 20px'
    }
  }, "Ton chien m\xE9rite", /*#__PURE__*/React.createElement("br", null), "un ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--teal)'
    }
  }, "\xE9t\xE9 parfait.")), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 18,
      lineHeight: 1.6,
      color: 'var(--ink-soft)',
      maxWidth: 480,
      margin: '0 0 28px'
    }
  }, "D\xE8s que la chaleur monte, IceDream lui offre un coin frais et respirant o\xF9 s'allonger. Lui, il se pose. Toi, tu arr\xEAtes de culpabiliser."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 14,
      flexWrap: 'wrap',
      marginBottom: 22
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    onClick: onShop,
    iconRight: /*#__PURE__*/React.createElement(IconArrowRight, {
      size: 18
    })
  }, "Offrir un coin frais \xE0 mon chien"), /*#__PURE__*/React.createElement(Button, {
    variant: "outline",
    size: "lg",
    onClick: onHow
  }, "Voir comment \xE7a marche")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 18,
      flexWrap: 'wrap',
      fontSize: 13,
      color: 'var(--muted)',
      fontWeight: 500
    }
  }, /*#__PURE__*/React.createElement("span", null, "Marque fran\xE7aise"), /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", null, "Livraison 7 \xE0 10 jours"), /*#__PURE__*/React.createElement("span", null, "\xB7"), /*#__PURE__*/React.createElement("span", null, "Satisfait ou rembours\xE9"))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderRadius: 'var(--radius-xl)',
      overflow: 'hidden',
      boxShadow: 'var(--shadow-lg)',
      aspectRatio: '4 / 3.4'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('product-icedream.png'),
    alt: "Chien d\xE9tendu sur le tapis IceDream",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      bottom: 18,
      left: -18,
      background: '#fff',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-md)',
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement(Rating, {
    value: 5,
    size: 16
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      color: 'var(--ink)',
      fontWeight: 600
    }
  }, "Des chiens pos\xE9s,", /*#__PURE__*/React.createElement("br", null), "des ma\xEEtres tranquilles")))));
}

/* ---------- Trust strip ---------- */
function TrustStrip() {
  const {
    IconWind,
    IconPlugOff,
    IconWash
  } = NS();
  const items = [{
    icon: /*#__PURE__*/React.createElement(IconWind, {
      size: 26
    }),
    t: 'Tissu respirant',
    d: 'Le coton laisse passer l’air au lieu de retenir la chaleur.'
  }, {
    icon: /*#__PURE__*/React.createElement(IconPlugOff, {
      size: 26
    }),
    t: 'Rien à brancher',
    d: 'Pas d’eau, pas d’électricité. Tu le poses au sol, c’est prêt.'
  }, {
    icon: /*#__PURE__*/React.createElement(IconWash, {
      size: 26
    }),
    t: 'Lavable en machine',
    d: 'Un tour en machine et il est comme neuf. Zéro entretien.'
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      borderBottom: '1px solid var(--line)',
      background: '#fff'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 28,
      padding: '34px 32px'
    }
  }, items.map(it => /*#__PURE__*/React.createElement("div", {
    key: it.t,
    style: {
      display: 'flex',
      gap: 14,
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 48,
      height: 48,
      borderRadius: 'var(--radius-md)',
      background: 'var(--teal-light)',
      color: 'var(--teal-deep)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    }
  }, it.icon), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15,
      fontWeight: 700,
      color: 'var(--ink)',
      marginBottom: 3
    }
  }, it.t), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      lineHeight: 1.45,
      color: 'var(--muted)'
    }
  }, it.d))))));
}

/* ---------- Emotion block ---------- */
function EmotionBlock({
  onShop
}) {
  const {
    Button,
    Eyebrow
  } = NS();
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--cream)'
    }
  }, /*#__PURE__*/React.createElement(Container, {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 48,
      alignItems: 'center',
      padding: '72px 32px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderRadius: 'var(--radius-xl)',
      overflow: 'hidden',
      boxShadow: 'var(--shadow-md)',
      aspectRatio: '5 / 4'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: window.CG_ASSET('homepage-hero.jpg'),
    alt: "Chien qui a chaud pr\xE8s de la fen\xEAtre",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, {
    style: {
      marginBottom: 14
    }
  }, "On conna\xEEt ce moment"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 34,
      lineHeight: 1.12,
      fontWeight: 800,
      letterSpacing: '-0.6px',
      color: 'var(--ink)',
      margin: '0 0 18px'
    }
  }, "14h, il fait 32\xB0. Et tu tournes en rond autant que lui."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 16,
      lineHeight: 1.6,
      color: 'var(--ink-soft)',
      margin: '0 0 14px'
    }
  }, "Il hal\xE8te. Il change de place toutes les dix minutes. Il finit coll\xE9 au carrelage de la cuisine, le seul endroit un peu frais de la maison."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 16,
      lineHeight: 1.6,
      color: 'var(--ink-soft)',
      margin: '0 0 26px'
    }
  }, "Toi, tu fermes les volets, tu remplis la gamelle d\u2019eau, et tu te dis que tu pourrais s\xFBrement faire mieux pour lui. C\u2019est pour toi, autant que pour lui, qu\u2019on a cr\xE9\xE9 Canigloo."), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onShop
  }, "D\xE9couvrir IceDream"))));
}
Object.assign(window, {
  Container,
  AnnouncementBar,
  SiteHeader,
  Hero,
  TrustStrip,
  EmotionBlock
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/shopify/sectionsTop.js", error: String((e && e.message) || e) }); }

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Card = __ds_scope.Card;

__ds_ns.Eyebrow = __ds_scope.Eyebrow;

__ds_ns.Input = __ds_scope.Input;

__ds_ns.Rating = __ds_scope.Rating;

__ds_ns.IconWind = __ds_scope.IconWind;

__ds_ns.IconPlugOff = __ds_scope.IconPlugOff;

__ds_ns.IconWash = __ds_scope.IconWash;

__ds_ns.IconTruck = __ds_scope.IconTruck;

__ds_ns.IconShield = __ds_scope.IconShield;

__ds_ns.IconLock = __ds_scope.IconLock;

__ds_ns.IconReturn = __ds_scope.IconReturn;

__ds_ns.IconBed = __ds_scope.IconBed;

__ds_ns.IconSmile = __ds_scope.IconSmile;

__ds_ns.IconSun = __ds_scope.IconSun;

__ds_ns.IconPaw = __ds_scope.IconPaw;

__ds_ns.IconChevronDown = __ds_scope.IconChevronDown;

__ds_ns.IconCart = __ds_scope.IconCart;

__ds_ns.IconArrowRight = __ds_scope.IconArrowRight;

__ds_ns.IconPlus = __ds_scope.IconPlus;

__ds_ns.IconMinus = __ds_scope.IconMinus;

__ds_ns.IconClose = __ds_scope.IconClose;

__ds_ns.IconMenu = __ds_scope.IconMenu;

__ds_ns.IconCheck = __ds_scope.IconCheck;

__ds_ns.IconHeart = __ds_scope.IconHeart;

})();
